
import { Injectable } from "@angular/core";
import { environment } from '../environments/environment';
import { HttpBackend, HttpClient, HttpContext, HttpParams } from "@angular/common/http";
import { SKIP_AUTH_REDIRECT } from "./service/interceptors/http-context.tokens";
import { LanguageService } from "./service/language-service/language.service";
import { BiometricAuthService } from "./service/biometric-auth/biometric-auth.service";
import {
	RoleplayEndResponseDto,
	RoleplayFramesResponseDto,
	RoleplayMineAllFiltros,
	RoleplayMineAllResponseDto,
	RoleplayRealtimeRole,
	RoleplayRealtimeTokenDto,
	RoleplayRealtimeTurnResponseDto,
	RoleplaySessionResultsDto,
	RoleplayStartResponseDto,
	RoleplayTextTurnRequestDto,
	RoleplayTopicResponseDto,
	RoleplayTurnResponseDto,
} from "./pages/evaluacion-practica/models/roleplay.model";
import { RutaResponse } from "./pages/learning-path/models/learning-path.model";
import { FirmaProyecto, FirmaProyectoResponse, FirmarProyectoResponse } from "./pages/learning-path/models/signature.model";
import { ResultadoEvaluacionResponse } from "./pages/learning-path/models/exam-result.model";
import { FirmaAsistenciaResponse, SesionDetalleResponse } from "./pages/learning-path/models/session-detail.model";
import { HomeIsaAnalysisResponse, HomeSummaryResponse } from "./pages/anuncios/models/home.model";
@Injectable({
	providedIn: "root",
})
export class ApiService {
	private lista_preguntas: any[] = [];
	private lista_encuesta: any[] = [];
	private _change_cursos: boolean = false;
	private _codigo_reunion: string = "";
  language:string = "es";
	//API URLs
	apiUrls = {
		serviceBase : environment.SERVICE_BASE,
		serviceBaseGestor : environment.SERVICE_BASE_GESTOR,
		serviceBaseRest : environment.SERVICE_BASE_REST,
		serviceBaseAuth : environment.SERVICE_BASE_AUTH,
		urlBase : environment.URL_BASE,
		urlReporte : environment.URL_REPORTE,
		urlAndroid: environment.APP_PLAYSTORE,
		urliOS: environment.APP_ID_IOS,
	};

	/**
	 * Cliente HTTP "crudo" que NO pasa por los interceptors de la app (no agrega
	 * auth ni los query params workstation/device/etc.). Se usa para descargar
	 * archivos externos (p.ej. el config-audio.json del podcast en un CDN), donde
	 * esos headers custom dispararían un preflight CORS que el CDN no responde.
	 */
	private rawHttp: HttpClient;

	constructor(
    public http: HttpClient,
    private languageService: LanguageService,
    httpBackend: HttpBackend,
    private biometric: BiometricAuthService,
  ) {
		this.rawHttp = new HttpClient(httpBackend);
		//console.log("api service", this.apiUrls)
		if(environment.APP_MULTIMARCA && (this.apiUrls.serviceBase === "" || !this.apiUrls.serviceBase)) {
			const apiUrlForBrand = localStorage.getItem("api_urls");
			if(apiUrlForBrand) {
				this.apiUrls = JSON.parse(apiUrlForBrand);
			}
		}

    this.subLanguageConfig();
	}

	// Setters & Getters
	public get getApiUrls() {
		return this.apiUrls;
	}
	public set setApiUrls(newUrls){
		this.apiUrls = newUrls;
	}

	public get change_cursos(): boolean {
		return this._change_cursos;
	}
	public set change_cursos(value: boolean) {
		this._change_cursos = value;
	}

	public get preguntas(): any {
		return this.lista_preguntas;
	}
	public get encuestas(): any {
		return this.lista_encuesta;
	}

	public get codigo_reunion(): string {
		return this._codigo_reunion;
	}
	public set codigo_reunion(value:string){
		this._codigo_reunion = value;
	}

  subLanguageConfig() {
    this.languageService.getCurrentLang().subscribe(lang => {
      this.language = lang;
    });
  }
	/***************  MULTIMARCA - PETICIÓN A MASTER *******************/
	getBrandApiConnections (user, password, ver_usu, ver_os, captchaToken, urlBase = null) {
		let url: string = environment.URL_MASTER + "/api/login";
		let body:any = {
			user,
			password,
			os: ver_os,
			version: ver_usu,
			"g-recaptcha-response": captchaToken,
		}
    if(urlBase) {
      body = {...body, company: urlBase};
    }
		return this.http
			.post(url, body)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
	}

  getEnviromentConfig(baseUrl, companySlug = null, workspaceId = null) {
    // https://gestiona.aruma.cursalab.io/
    let params= "";
    if(companySlug) {
      params = `?companySlug=${companySlug}`;
    }
    if(workspaceId) {
      params = params ? `${params}&workspaceId=${workspaceId}` : `?workspaceId=${workspaceId}`;
    }
		let url: string = baseUrl + (baseUrl.includes("api/") ? `environment-configuration${params}` : `api/environment-configuration${params}`);
		return this.http.get<any>(url)
	}





  getEnviromentUrlBase(companySlug) {
		let url: string = environment.URL_MASTER + `/api/company/${companySlug}`;
		return this.http.get<any>(url)
	}

  /**
   * URLs de SSO habilitadas para el entorno (Google / Microsoft). Endpoint
   * hermano de `environment-configuration`: vive en la API de la marca, así que
   * la URL ya identifica el entorno y NO necesita `company`.
   *
   * Solo devuelve `url_sso_*` para los proveedores habilitados; el resto llega
   * en `null`.
   *
   * @param baseUrl origen de la marca (solo multimarca). Se obtiene de
   *        `loginMultiModuloService.getActiveBrandCompany()`.
   * @param origin `window.location.host` del cliente que hace la petición: el
   *        backend lo necesita para saber a dónde redirigir en caso de error.
   * @param os plataforma del cliente: `"web" | "android" | "ios"`.
   */
  getEnviromentSSO(baseUrl = null, origin: string = null, os: string = null) {
    let url: string;
    if (environment.APP_MULTIMARCA) {
      url = baseUrl + (baseUrl.includes("api/") ? `environment-sso` : `api/environment-sso`);
    } else {
      url = this.apiUrls.serviceBase + "environment-sso";
    }

    let params = new HttpParams();
    if (origin) {
      params = params.append("origin", origin);
    }
    if (os) {
      params = params.append("os", os);
    }

		return this.http.get<any>(url, { params })
	}

  getBaseConfig(serviceBase) {
    let url: string = serviceBase + `config_ambiente`;
    // console.log("get getBaseConfig!!", url);
		// let url: string = serviceBase + ` config_ambiente/${workspaceId}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	/** esta api ya no devuelve las rutas, el envio de correo de recuperación se hace internamente en el backend. */
	getBrandApiConnectionsChangePassword (email, company = null) {
		let url: string = environment.URL_MASTER + "/api/recuperar_password";
		let params = new HttpParams().set('email', email);
		if(company) {
			params = params.set('company', company);
		}
		let promesa = this.http
		.get(url, { params })
		.toPromise()
		.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
		.catch((error) => Promise.reject(error));
		return promesa;
	}

	/** esta api devuelve las rutas, pero se debe enviar el token que viene en el enlace de recuperar contraseña. */
	getBrandApiConnectionsChangePasswordValidateToken (email, token, company = null) {
		let url: string = environment.URL_MASTER + "/api/validate/email-token";
		let body:any = {
			email,
			token
		}
		if(company) {
			body = {...body, company};
		}
		let promesa = this.http
		.post(url, body)
		.toPromise()
		.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
		.catch((error) => Promise.reject(error));
		return promesa;
	}


	/********************* AUTH - LOGIN *************************/

	/*impersonation - gestor-app */
	loginImpersonationSession(token, expires, signature, UrlBase, isAzure) {
		let url:string = "";
		if(environment.APP_MULTIMARCA) {
			 url = UrlBase + `/api/auth/login/external/${token}`;
		} else {
			url = this.apiUrls.serviceBaseAuth + `login/external/${token}`;
		}

		let params = new HttpParams();
    if(isAzure) {
      params = params.append("azure",isAzure);
    }
		params = params.append("expires",expires);
		params = params.append("signature",signature);

    console.log(url);

		return this.http
			.post(url, {}, {
				params
			})
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
	}
	/*** Login **/
	getConfig () {
		let url: string = this.apiUrls.serviceBase + "config_ambiente";
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	login(usuario: string = null, pass: string = null, ver_usu: string, ver_os: string, captchaToken) {
		let body = {
			user:usuario,
			password:pass,
			os: ver_os,
			version: ver_usu,
			"g-recaptcha-response": captchaToken,
		}
		let url = this.apiUrls.serviceBaseAuth + "login";
		return this.http
			.post(url, body)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
	}

	loginMultibrandWithCustomBaseUrl(baseUrl,usuario: string = null, pass: string = null, ver_usu: string, ver_os: string, captchaToken) {
		let body = {
			user:usuario,
			password:pass,
			os: ver_os,
			version: ver_usu,
			"g-recaptcha-response": captchaToken,
		}
    let url: string = baseUrl + (baseUrl.includes("api/") ? `auth/login` : `api/auth/login`);

		// let url = baseUrl + "api/auth/login";
		return this.http
			.post(url, body)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
	}
	// Recuperar contraseña - Envío de correo
	recuperar_contra(email: string = null) {
		const body = { email };

		let url = this.apiUrls.serviceBase + "password/email";
		return this.http
			.post(url, body)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
	}
	// Cambiar contraseña
	cambiar_contra(
		email: string = null,
		password: string = null,
		password_rec: string = null,
		token: string = null,
		os: string = null,
		version: string = null
	) {
		let body = {
			email: email.toString(),
			password,
			password_confirmation: password_rec,
			token,
			os,
			version,
		};
		let url = this.apiUrls.serviceBase + "password/reset";
		return this.http
			.post(url, body)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
	}
	//APIs seguridad
	updateSecurePassword(
		email: string = null,
		document: string = null,
		password: string = null,
		password_confirmation: string = null,
		token: string = null,
		os: string = null,
		version: string = null
	) {
		let body:any = {
			password,
			password_confirmation,
			token,
			os,
			version,
		};

		email ? body= {...body, email} : body= {...body, document};

		let url = this.apiUrls.serviceBase + "reset";
		return this.http
			.post(url, body)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
	}
	updatePasswordVoluntarily(formValue) {
		let body:any = {
			oldPassword:formValue.actualPassword,
			newPassword:formValue.newPassword,
			newPasswordConfirmation:formValue.confirmNewPassword,
		};
		let url = this.apiUrls.serviceBase + "users/password/reset";
		return this.http
			.post(url, body)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
	}

	identityValidation(birthdate: string = null, gender: string = null, id_user) {
		let body: any = {
			id_user,
		};

		if(birthdate && !gender){
			body= {...body, birthday_date: birthdate.toString()} ;
		} else if(birthdate && gender) {
			body= {...body, birthday_date: birthdate.toString(), gender: gender} ;
		}

		let url = this.apiUrls.serviceBase + "quizz";
		return this.http
			.post(url, body)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
	}

	/*** Función para cerrar sesión */
	// async logout() {
	// 	await this.logout_token()
	// 		.then((res) => {
	// 			this.up.clearStorage();
	// 			// this.stopRefreshToken();
	// 		})
	// 		.catch((e) => {
	// 			console.log(e.status, e.url);
	// 		});
	// }

	/* Request al API para revocar el token */
	logout_token() {
		let url = this.apiUrls.serviceBaseAuth + "logout";

		// let body = {
		// 	// token: localStorage.getItem("token"),
		// };

		this.biometric.markSkipNextAutoLogin();

		return this.http
			.post(url, {})
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
	}

	/**
	 * Obtiene un token de sesión propio de una plataforma distinta a
	 * aprendizaje/inducción (ej. Desempeño). Se envía con el token de sesión
	 * original del login (lo agrega el interceptor) y el código de la plataforma
	 * destino. La respuesta trae el nuevo token en `data.token`.
	 */
	platformLoginToken(platform: string) {
		let url = this.apiUrls.serviceBaseRest + "auth/platform-login-token";
		let body = { platform };
		return this.http
			.post(url, body)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
	}

	/**
	 * Función para refrescar token
	 */
	// refreshToken() {
	// 	let url = this.ruta_auth + "refresh";
	// 	return this.http
	// 		.post(url, {})
	// 		.toPromise()
	// 		.then((res) => Promise.resolve(JSON.parse(JSON.stringify(res))))
	// 		.catch((err) => Promise.reject(err));
	// }

	// private refreshTokenTimeout;

	// startRefreskToken(expires_tk: number) {
	// const expires = expires_tk * 1000;
	// console.log(expires);
	// const timeout = expires - (20 * 1000);
	// console.log(timeout);
	// this.refreshTokenTimeout = setTimeout( () => {
	// 	this.refreshToken().then( res => {
	// 		console.log(res);
	// 		localStorage.setItem("token", res.access_token);
	// 		this.startRefreskToken(res.expires_in);
	// 	})
	// }, timeout);

	// 	console.log("Temporalmente no está activo refrescar token...");
	// }

	// stopRefreshToken() {
	// 	clearTimeout(this.refreshTokenTimeout);
	// }

	guardar_token_fcm(token: any) {
		let url: string = this.apiUrls.serviceBaseRest + "guardar_token_firebase";
		console.log(url);

		let body = {
			fcm_token: token.toString(),
		};

		let promesa = this.http
			.post(url, JSON.stringify(body))
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		console.log(promesa);
		return promesa;
	}

	getEmailValidation(email) {
		let url = `${this.apiUrls.serviceBaseRest}existe_email/${encodeURIComponent(email)}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	guardarSoporteLogin(form) {
		let url: string = this.apiUrls.serviceBaseRest + "registrar_soporte_login";

		let body = {
			dni: form.documento,
			phone: form.celular,
			email: form.email,
			details: form.detalle,
		};

		let promesa = this.http
			.post(url, body)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}


	userValidation(form, company = null) {
		let url: string = environment.URL_MASTER + "/api/registrar_soporte_login";

		let body:any = {
			dni: form.documento,
			phone: form.celular,
			email: form.email,
			details: form.detalle,
		};

		if(company) {
			body = {...body, company};
		}

		let promesa = this.http
			.post(url, body)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}


	listarEmpresasLogin() {
		let url: string = this.apiUrls.serviceBaseRest + "listar_empresas";
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	/********************* / AUTH - LOGIN *************************/

	/********************* ANUNCIOS  *************************/
	cargar_anuncios() {
		let url: string = this.apiUrls.serviceBaseRest + "announcements";
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	showModalOrder(company = null) {
    let url:string = "";
    let params = new HttpParams();
    if(environment.APP_MULTIMARCA) {
      url =  environment.URL_MASTER + "/api/notifications";
      // Sin `company` el master solo puede devolver el aviso global, no el de la marca.
      if(company) {
        params = params.set('company', company);
      }
    } else {
      url = this.apiUrls.serviceBase + "notifications";
    }
		return new Promise((resolve, reject) => {
			this.http
				.get(url, { params })
				.toPromise()
				.then((res) => {
				    // console.log(res);
				   resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}




	/********************* / ANUNCIOS  *************************/

	/*********************  CURSOS - TEMAS *************************/

	// get Escuelas
	cargarEscuelas() {
		return new Promise((resolve, reject) => {
			this.http
				.get(this.apiUrls.serviceBaseRest + "cursos")
				.toPromise()
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}

	descargarVimeo(vimeo_code) {
		return new Promise((resolve, reject) => {
			this.http
				.get(this.apiUrls.serviceBaseRest + `vimeo/get_download_link_vimeo/${vimeo_code}`)
				.toPromise()
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}
	/********************* / CURSOS - TEMAS *************************/

	/********************* EVALUACIONES  *************************/

	// Evaluacion
	// cargarEvaluacion(tema_id) {
	// 	return new Promise((resolve, reject) => {
	// 		this.http
	// 			.get(this.apiUrls.serviceBaseRest + "cargar_preguntas/" + tema_id)
	// 			.toPromise()
	// 			.then((res) => {
	// 				resolve(res);
	// 			})
	// 			.catch((err) => {
	// 				reject(err);
	// 			});
	// 	});
	// }
	cargarEvaluacion(tema_id, userDate?, is_offline = false) {
		let url = is_offline ? 	`?user_datetime=${userDate}&is_offline=${is_offline}` : `?user_datetime=${userDate}`
		return new Promise((resolve, reject) => {
			this.http
				.get(this.apiUrls.serviceBaseRest + "cargar_preguntas/" + tema_id + `${url}`)
				.toPromise()
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}
	// Enviar evaluacion
	enviarEvaluacion(params) {
		return new Promise((resolve, reject) => {
			this.http
				.post(this.apiUrls.serviceBaseRest + "evaluar_preguntas", params)
				.toPromise()
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}
	// Enviar evaluacion scorm
	/**
	 * Opciones de un request disparado por la reproducción de un SCORM: con `skipAuthRedirect`, un
	 * 401 no manda a `/login` (ver `SKIP_AUTH_REDIRECT`). Sin él, `{}` — igual que antes.
	 */
	private scormPlaybackOptions(skipAuthRedirect: boolean) {
		return skipAuthRedirect ? { context: new HttpContext().set(SKIP_AUTH_REDIRECT, true) } : {};
	}

	saveScormEvaluation(params, skipAuthRedirect = false) {
		return new Promise((resolve, reject) => {
			this.http
				.post(this.apiUrls.serviceBaseRest + "save_scorm_evaluation", params, this.scormPlaybackOptions(skipAuthRedirect))
				.toPromise()
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}

  validateEvaluation(identifier, course_id, topic_id, brand_url) {
    let params = new HttpParams()
      .set('identifier', identifier)
      .set('course_id', course_id)
      .set('topic_id', topic_id);
		return new Promise((resolve, reject) => {
			this.http
      .get(brand_url +"/api/rest/validate-info-quiz", { params })
				.toPromise()
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
  }
	// Enviar Intento
	// Fuente siempre sera app
	// evaluacionIntento(post_id) {
	// 	return new Promise((resolve, reject) => {
	// 		this.http
	// 			.get(this.apiUrls.serviceBaseRest + `preguntasintentos_v7/${post_id}/app`)
	// 			.toPromise()
	// 			.then((res) => {
	// 				resolve(res);
	// 			})
	// 			.catch((err) => {
	// 				reject(err);
	// 			});
	// 	});
	// }

	// Revisar Tema
	revisarTema(tema_id) {
		return new Promise((resolve, reject) => {
			this.http
				.get(this.apiUrls.serviceBaseRest + `temas/actividad_tema_revisado/${tema_id}`)
				.toPromise()
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}

	// Consultar respuestas de usuario por tema
	usuario_respuestas_eval(post_id: number) {
		let url: string = this.apiUrls.serviceBaseRest + "usuario_respuestas_eval/" + post_id;

		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	// Carga las preguntas de un determinado post (evaluación)
	async preguntas_rptas_usuario(id: number = null) {
		if (id != null) {
			let url: string = this.apiUrls.serviceBaseRest + "preguntas_rptas_usuario/" + id;
			let promesa = await this.http
				.get(url)
				.toPromise()
				.then(async (response) => await Promise.resolve(JSON.parse(JSON.stringify(response))))
				.catch((error) => Promise.reject(error));
			return promesa;
		}
	}

	updateRespuestasAbiertas(post_id: number, user_id: number, rptas: any[] = null) {
		if (post_id != null && user_id != null) {
			let url: string = this.apiUrls.serviceBaseRest + "evaluar_abiertas";
			console.log(url);
			let params = {
				post_id: post_id.toString(),
				user_id: user_id.toString(),
				rptas: encodeURIComponent(JSON.stringify(rptas)),
				fuente: "app",
			};

			let promesa = this.http
				.post(url, JSON.stringify(params))
				.toPromise()
				.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
				.catch((error) => Promise.reject(error));

			return promesa;
		}
	}

	// carga las encuesta de un determinado post  (encuestas)
	// `poll_id` (ruta, fase 5a): opcional y aditivo — solo agrega el query param cuando llega, así
	// que los llamadores existentes (encuesta final de curso clásico / inducción) arman la misma URL
	// de siempre. Elige cuál encuesta llega quien SÍ lo manda (la ruta).
	// `course_block_id` (ruta): igual de opcional — la misma encuesta puede estar en varios temas y
	// dice cuál de esos lugares se abre. Solo va junto con `poll_id`.
	cargar_encuestas_curso(curso_id: number = null, poll_id: number = null, course_block_id: number = null) {
		if (curso_id != null) {
			let url: string = this.apiUrls.serviceBaseRest + "cursos/cargar_encuestas_curso/" + curso_id;
			if (poll_id != null) {
				url += "?poll_id=" + poll_id;
				if (course_block_id != null) {
					url += "&course_block_id=" + course_block_id;
				}
			}
			// console.log(url);
			let promesa = this.http
				.get(url)
				.toPromise()
				.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
				.catch((error) => Promise.reject(error));
			return promesa;
		}
	}

	// Carga preguntas encuestas libres
	preguntas_enc_libre(enclibre_id: number = null) {
		if (enclibre_id != null) {
			let url: string = this.apiUrls.serviceBaseRest + "preguntas_enc_libre/" + enclibre_id;

			let promesa = this.http
				.get(url)
				.toPromise()
				.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
				.catch((error) => Promise.reject(error));
			return promesa;
		}
	}

	// Guarda las encuestas del post que realizó el usuario - POST
	// `course_block_id` (ruta): el lugar de la ruta donde se respondió. Solo viaja si llega; la
	// encuesta del clásico y `encuesta-preguntas` mandan el mismo cuerpo de siempre.
	guardar_encuestas_curso (
		enc_id: number = null,
		user_id: number = null,
		curso_id: number = null,
		data: any[] = null,
		course_block_id: number = null
	) {
		if (enc_id != null || user_id != null) {
			let url: string = this.apiUrls.serviceBaseRest + "cursos/guardar_encuesta_curso_id";

			let curso = null;
			if (curso_id) {
				curso = curso_id.toString();
			}
			let params: Record<string, unknown> = {
				enc_id: enc_id.toString(),
				user: user_id.toString(),
				curso: curso,
				data: data,
			};
			if (course_block_id != null) {
				params.course_block_id = course_block_id;
			}

			// params = params.append('enc_id', enc_id.toString());
			// params = params.append('user', user_id.toString());
			// params = params.append('curso', curso);
			// let dataenc = encodeURIComponent(JSON.stringify(data));
			// params = params.append('data', dataenc);

			let promesa = this.http
				.post(url, JSON.stringify(params))
				.toPromise()
				.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
				.catch((error) => Promise.reject(error));
			return promesa;
		}
	}
	guardar_encuestas_libre(
		enc_id: number = null,
		data: any[] = null
	) {

			let url: string = this.apiUrls.serviceBaseRest + "guardar_enc_libre_id";
			let params = {
				enc_id: enc_id.toString(),
				data: data,
			};

			let promesa = this.http
				.post(url, JSON.stringify(params))
				.toPromise()
				.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
				.catch((error) => Promise.reject(error));
			return promesa;

	}

	/********************* / EVALUACIONES  *************************/

	/********************* FUNCIONES *************************/

	async cargarEncuestasCurso(curso_id: number = null) {
		this.lista_encuesta = [];
		// console.log(curso_id);
		if (curso_id != null) {
			await this.cargar_encuestas_curso(curso_id)
				.then(
					async (response) => {
						if (response.error == 0) console.log(response.data);
						this.lista_encuesta = await response.data.poll.questions;
					},
					(error) => {
						console.log(error);
					}
				)
				.catch((e) => {
					console.log(e.status, e.url);
				});
		}
	}

	async cargarPregEncLibre(enclibre_id: number = null) {
		if (enclibre_id != null) {
			await this.preguntas_enc_libre(enclibre_id)
				.then(
					async (response) => {
						this.lista_encuesta = await response.data.questions;
					}
				)
				.catch((e) => {
					console.log(e.status, e.url);
				});
		}
	}

	// Consultar preguntas segun respuestas de usuario
	async preguntasRptasUsuario(id: number = null) {
		if (id != null) {
			await this.preguntas_rptas_usuario(id)
				.then(
					async (result) => {
						if ((await result.data) != null) {
							let myarray = result.data;
							let currentIndex = myarray.length;
							let temporayValue, randomIndex;

							while (0 !== currentIndex) {
								randomIndex = Math.floor(Math.random() * currentIndex);
								currentIndex -= 1;

								temporayValue = myarray[currentIndex];
								myarray[currentIndex] = myarray[randomIndex];
								myarray[randomIndex] = temporayValue;
							}

							this.lista_preguntas = myarray;
							console.log(this.lista_preguntas);
						}
					},
					(error) => {
						console.log(error);
					}
				)
				.catch((e) => {
					console.log(e.status, e.url);
				});
		}
	}

  getExternalSurveyData(pollId,entityId, UrlBase = null) {
    let url:string = "";
		if(UrlBase) {
			 url = UrlBase + `/api/rest/external-poll/${pollId}/${entityId}`;
		} else {
			url = this.apiUrls.serviceBaseRest + `external-poll/${pollId}/${entityId}`;
		}
    // return this.http.get(url);

    let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
  }

  saveExternalSurveyData(pollId, entityId, body, UrlBase = null) {
    let url:string = "";
		if(UrlBase) {
			 url = UrlBase + `/api/rest/save-external-poll/${pollId}/${entityId}`;
		} else {
			url = this.apiUrls.serviceBaseRest + `save-external-poll/${pollId}/${entityId}`;
		}
    let promesa = this.http
    .post(url, body)
    .toPromise()
    .then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
    .catch((error) => Promise.reject(error));
  return promesa;
  }
	/********************* / FUNCIONES *************************/

	/*********************  PROGRESO *************************/

	// Cargar Progreso
	cargarProgreso() {
		return new Promise((resolve, reject) => {
			this.http
				.get(this.apiUrls.serviceBaseRest + "progreso")
				.toPromise()
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}

	/** Un bloque de la ruta con sus filas (`ProgresoBloqueResponse`): lo pide la vista al desplegarlo. */
	cargarProgresoBloque(courseId: number, bloqueId: number) {
		return this.http
			.get(this.apiUrls.serviceBaseRest + `progreso/cursos/${courseId}/bloques/${bloqueId}`)
			.toPromise();
	}

	cargarProgresoDetalle() {
		return new Promise((resolve, reject) => {
			this.http
				.get(this.apiUrls.serviceBaseRest + "progreso/v2/detail_progress")
				.toPromise()
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}

	cargarProgresoEscuelas(tipo) {
		const params = {
			tipo,
		};
		return new Promise((resolve, reject) => {
			this.http
				.post(this.apiUrls.serviceBaseRest + "progreso/v2/schools", JSON.stringify(params))
				.toPromise()
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}

	cargarProgresoCursos(school) {
		const params = {
			school,
		};
		return new Promise((resolve, reject) => {
			this.http
				.post(this.apiUrls.serviceBaseRest + "progreso/v2/courses_by_school", JSON.stringify(params))
				.toPromise()
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}

	// Cargar cursos de escuela seleccionada
	schoolCourses(escuela_id) {
		return new Promise((resolve, reject) => {
			this.http
				.get(this.apiUrls.serviceBaseRest + "progreso/school/" + escuela_id)
				.toPromise()
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}
// obtener ranking
	cargarRanking() {
		let url = this.apiUrls.serviceBaseRest + "ranking/v2";
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	criterioRanking(code) {
		let url = this.apiUrls.serviceBaseRest + `ranking/criterion-code/${code}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	getCurso(curso_id, escuela_id) {
		let url: string = this.apiUrls.serviceBaseRest + `temas/${curso_id}?school_id=${escuela_id}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	getListTemas(curso_id, escuela_id) {
		let url: string = this.apiUrls.serviceBaseRest + `temas/v2/${curso_id}?school_id=${escuela_id}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) =>
				Promise.resolve(this.simularLlavesRoleplay(JSON.parse(JSON.stringify(response))))
			)
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	/**
	 * Carga inicial de un curso en formato ruta: un solo pedido trae el breadcrumb,
	 * el ítem en el que va el usuario con sus vecinos, los bloques con sus ítems,
	 * el avance y las monedas.
	 *
	 * Hermana de `getListTemas` (`temas/v2`): a qué de las dos llamar lo decide el
	 * `format` que el listado de cursos ya trae por curso (`classic` / `path`).
	 * Devuelve un Observable tipado a propósito —el estilo de la zona nueva de la
	 * clase— porque la vista necesita distinguir el 403 y el 422 del contrato, y
	 * con `toPromise()` el cuerpo del error se pierde de vista.
	 */
	obtenerRutaCurso(curso_id: number | string, school_id?: number | string | null) {
		let url: string = this.apiUrls.serviceBaseRest + `cursos/${curso_id}/ruta`;
		if (school_id !== null && school_id !== undefined && school_id !== "") {
			url += `?school_id=${school_id}`;
		}
		// `workstation`, `device`, `user_timezone` y `userLanguage` los agregan los
		// interceptores; acá solo va lo propio de la ruta.
		return this.http.get<RutaResponse>(url);
	}

	/**
	 * Resultado de una evaluación ya rendida (ruta, `exam` / `evaluation`): lo mismo que devuelve
	 * `evaluar_preguntas` al rendir, sin volver a rendir. `topic_id` es el `ref.topic_id` del ítem.
	 * Solo lee la ficha del propio usuario; con `evaluado: false` todo viene vacío salvo `intentos`.
	 */
	obtenerResultadoEvaluacion(topic_id: number | string) {
		return this.http.get<ResultadoEvaluacionResponse>(
			this.apiUrls.serviceBaseRest + `resultado_evaluacion/${topic_id}`
		);
	}

	/**
	 * Detalle de una sesión presencial de una ruta (fase sesiones con ítems). Mismo endpoint para
	 * alumno y facilitador; `rol` en la respuesta dice cuál es. Observable tipado por la misma razón
	 * que `obtenerRutaCurso`: la vista necesita el cuerpo del error para mostrarlo.
	 */
	obtenerSesionPresencial(curso_id: number | string, meeting_id: number | string) {
		return this.http.get<SesionDetalleResponse>(
			this.apiUrls.serviceBaseRest + `cursos/${curso_id}/sesiones/${meeting_id}`
		);
	}

	/** Firma de la propia asistencia del alumno a una sesión presencial de una ruta. */
	firmarAsistenciaSesion(curso_id: number | string, meeting_id: number | string, signature: string) {
		return this.http.post<FirmaAsistenciaResponse>(
			this.apiUrls.serviceBaseRest + `cursos/${curso_id}/sesiones/${meeting_id}/firma`,
			{ signature }
		);
	}

	// ── [PRUEBA ROLEPLAY] Completa (o inventa) el bloque `roleplay` del tema ────
	//
	// `temas/v2` es el único punto por donde entra el payload de los temas, así
	// que el parche vive acá y ninguna vista se entera. Hace dos cosas:
	//
	//   1. Si backend ya manda `roleplay`, solo completa las llaves que todavía
	//      no existen (las de nota). La llave real siempre gana.
	//   2. Si no lo manda, lo inventa entero — el espacio con roleplay real está
	//      caído y hay que poder probar el flujo en cualquier otro.
	//
	// ⚠️ QUITAR ANTES DE PRODUCCIÓN: SIMULAR_LLAVES_ROLEPLAY = false y borrar
	// este bloque junto con `simularLlavesRoleplay()`.

	private readonly SIMULAR_LLAVES_ROLEPLAY = false;

	/**
	 * A qué temas se les inventa el objeto cuando la API no lo trae.
	 * 'todos' | 'primer-tema' (el primero de cada curso) | 'ninguno' | [ids].
	 */
	private readonly FORZAR_ROLEPLAY_EN: 'todos' | 'primer-tema' | 'ninguno' | number[] = 'todos';

	/**
	 * El objeto tal cual lo va a mandar backend. Editar a mano para probar
	 * escenarios; para probar varios a la vez, usar `ROLEPLAY_POR_TEMA`.
	 */
	private readonly ROLEPLAY_BASE = {
		has: true,
		is_evaluable: true,
		grade_mode: 'separate',        // 'separate' | 'averaged_with_exam'
		is_averaged: false,
		student_mode: 'chat',         // 'chat' | 'voice' | 'video' | 'streaming'
		max_attempts: 3,               // null | 0 = sin intentos ⇒ no puede darla
		attempts: 0,                   // > 0 ⇒ ya la rindió
		passed: null,                  // true | false | null (null = sin evaluar)
		allow_practice_after_pass: true, // false ⇒ aprobada no se repite, aunque queden intentos
		scenario: {
			// Escenario real del agente: es el que usaba `RoleplayService.SCENARIO_ID`.
			id: '6a6cfb92ee101f10d4100971',
			title: 'Atención a Cliente Molesto por Demora',
		},
		// TODO(api): llaves de nota ya pedidas a backend.
		grade: null,
		min_grade: 14,
		max_grade: 20,
	};

	/** Overrides por tema, para ver varios escenarios en una sola pasada. */
	private readonly ROLEPLAY_POR_TEMA: Record<number, any> = {
		// 354: { attempts: 3, max_attempts: 3 },                  // sin intentos
		// 355: { attempts: 1, passed: true, grade: 17 },          // realizada y aprobada
		// 356: { is_evaluable: false },                           // solo un paso a completar
		// 357: { max_attempts: null },                            // sin intentos: bloqueada
		// 358: { attempts: 1, passed: true, allow_practice_after_pass: false }, // aprobada, sin repetir
	};

	/**
	 * Pisa `estado_tema` para que un tema SIN teórica no se dé por completo con
	 * el roleplay pendiente.
	 *
	 * ⚠️ Backend ya lo va a resolver por su lado; prender solo para probarlo
	 * antes de que llegue.
	 */
	private readonly SIMULAR_CONSOLIDACION_ESTADO_TEMA = false;

	/** [PRUEBA ROLEPLAY] Ver el bloque de constantes de arriba. */
	private simularLlavesRoleplay(response: any) {
		if (!this.SIMULAR_LLAVES_ROLEPLAY) return response;

		const cursos = response?.data?.cursos;
		if (!Array.isArray(cursos)) return response;

		cursos.forEach((curso) => {
			if (!Array.isArray(curso?.temas)) return;

			curso.temas.forEach((tema, i) => {
				if (!tema) return;

				if (tema.roleplay) {
					// Backend ya lo manda: solo se completa lo que falte.
					this.completarLlavesFaltantes(tema.roleplay, this.ROLEPLAY_BASE);
				} else if (this.debeForzarRoleplay(tema, i)) {
					tema.roleplay = JSON.parse(JSON.stringify(this.ROLEPLAY_BASE));
				}

				// El override es explícito: pisa, no completa.
				const override = this.ROLEPLAY_POR_TEMA[tema.id];
				if (override && tema.roleplay) Object.assign(tema.roleplay, override);

				this.simularEstadoTema(tema);
			});
		});

		return response;
	}

	private debeForzarRoleplay(tema: any, indice: number): boolean {
		const donde = this.FORZAR_ROLEPLAY_EN;
		if (donde === 'ninguno') return false;
		if (donde === 'todos') return true;
		if (donde === 'primer-tema') return indice === 0;
		return Array.isArray(donde) && donde.includes(tema.id);
	}

	/** Copia solo las llaves que el destino todavía no tiene. */
	private completarLlavesFaltantes(destino: any, origen: any) {
		Object.keys(origen).forEach((llave) => {
			if (destino[llave] === undefined) {
				destino[llave] = JSON.parse(JSON.stringify(origen[llave]));
			}
		});
	}

	/**
	 * Un tema sin evaluación teórica (`evaluable: 'no'`) hoy pasa a `revisado` al
	 * terminar el último media, y con eso se pinta el ✓ verde, avanza de tema y
	 * llega a marcar el curso completado — todo sin haber dado el roleplay.
	 *
	 * Solo se degrada en ese caso: hacerlo en un tema con teórica rompería el
	 * badge de nota, que exige `estado_tema` en aprobado/desaprobado.
	 */
	private simularEstadoTema(tema: any) {
		if (!this.SIMULAR_CONSOLIDACION_ESTADO_TEMA) return;
		if (tema?.evaluable !== 'no') return;
		if (!tema?.roleplay?.has) return;
		if ((tema.roleplay.attempts ?? 0) > 0) return;

		tema.estado_tema = 'por-iniciar';
	}
	getListCursos(escuela_id) {
		let url: string = this.apiUrls.serviceBaseRest + `temas/${escuela_id}/list-courses`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	getTimeIntentos(tema_id) {
		let url: string = this.apiUrls.serviceBaseRest + `contador_tema_reseteo/${tema_id}`;
		let promesa = this.http
			.post(url, {})
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	// Conteo de visitas en los temas (topics)
	visitas_temas(tema_id) {
		let url: string = this.apiUrls.serviceBaseRest + `upd_reproducciones/${tema_id}`;
		let promesa = this.http
			.post(url, {})
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	sendSignatureMethod(canvaImgData, courseID) {
    const body = {
      signature: canvaImgData,
      course_id: courseID,
    }
		let url: string = this.apiUrls.serviceBaseRest + "cursos/registro-capacitacion";
		const token: string = localStorage.getItem("token");

    let promesa = this.http
    .post(url, body)
    .toPromise()
    .then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
    .catch((error) => Promise.reject(error));
    return promesa;

	}
	sendCertificateSignatureMethod(canvaImgData, courseID) {
    const body = {
      signature: canvaImgData,
      course_id: courseID,
    }
		let url: string = this.apiUrls.serviceBaseRest + "cursos/registro-personalizado";

    let promesa = this.http
    .post(url, body)
    .toPromise()
    .then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
    .catch((error) => Promise.reject(error));
    return promesa;

	}

	//Diplomas
	aceptarDiploma(courseId) {
		let url: string = this.apiUrls.serviceBaseRest + `cursos/aceptar-diploma/${courseId}`;
		let promesa = this.http
			.post(url, {})
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	lista_diplomas(currentPage, modality, palabra?, status?, schoolId?){
		let text_palabra = "";
		let text_status = "";
		let text_schoolID = "";
		if (palabra) text_palabra = palabra;
		if (status) text_status = `&type=${status}`;
		if (schoolId) text_schoolID = `&schoolId=${schoolId}`;

		let url: string = this.apiUrls.serviceBaseRest +
		`cursos/v3/diplomas?modality=${modality}&q=${text_palabra + text_status  + text_schoolID}&page=${currentPage}`;

		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}
	// lista_diplomas(palabra?, status?, schoolId?){
	// 	let text_palabra = "";
	// 	let text_status = "";
	// 	let text_schoolID = "";
	// 	if (palabra) text_palabra = palabra;
	// 	if (status) text_status = `&type=${status}`;
	// 	if (schoolId) text_schoolID = `&schoolId=${schoolId}`;

	// 	let url: string = this.apiUrls.serviceBaseRest +
	// 	`cursos/diplomas?q=${text_palabra + text_status  + text_schoolID}`;

	// 	let promesa = this.http
	// 		.get(url)
	// 		.toPromise()
	// 		.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
	// 		.catch((error) => Promise.reject(error));
	// 	return promesa;
	// }
	getChecklistReportsInCertificates(palabra?){
		let text_palabra = "";
		if (palabra) text_palabra = palabra;

		let url: string = this.apiUrls.serviceBaseRest +
		`cursos/diplomas/checklist`;

		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}
	validateChecklistInCertificates(){
		let url: string = this.apiUrls.serviceBaseRest +
		`cursos/diplomas/init-data`;

		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	/********************* / PROGRESO *************************/

	/*********************  REPORTES *************************/
	CargaInicial() {
		let url: string = this.apiUrls.serviceBaseRest + `reportes-supervisores/init`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	getReportChart(reportType, filters = null) {
		let url: string = this.apiUrls.serviceBaseRest + `reportes-supervisores/info`;
    let body:any = {
      report_type: reportType
    }
    if(filters) {
      body.filters = filters;
    };
    return this.http.post<any>(url, body);
	}

	getReportTable(reportType, filters = null, page ,perPage) {
		let url: string = this.apiUrls.serviceBaseRest + `reportes-supervisores/search?page=${page}&paginate=${perPage}`;
    let body:any = {
      report_type: reportType
    };
    if(filters) {
      body.filters = filters;
      // {
      //   search: "48484848",
      //   status: [
      //       "completed", "pending"
      //   ],
      //   schools: [12,25],
      //   courses: [255,63]
      // }
    };
    return this.http.post<any>(url, body);
	}

	sendJustificationFile(file, user_id, course_id, comment) {
    let url: string = this.apiUrls.serviceBaseRest + `reportes-supervisores/update-observations`;
    const token: string = localStorage.getItem("token");
    let data_usuario = JSON.parse(localStorage.getItem("user_data"));

    const workstation = {
      platform: data_usuario?.onboarding ? "onboarding" : "training",
      platform_id: data_usuario?.current_platform?.id,
      workspace: data_usuario?.workspace?.slug,
      workspace_id: data_usuario?.workspace?.id,
      subworkspace: data_usuario?.module?.slug,
      subworkspace_id: data_usuario?.module?.id,
    }

    // let body:any = {
    //   files: file,
    //   user_id: null,
    //   course_id: null,
    //   comment: null
    // };
    // return this.http.post<any>(url, body);
    let action = '';
    if(file && comment) {
      action = 'file_comment';
    };
    if(file && !comment) {
      action = 'update_file';
    };
    if(!file && comment) {
      action = 'update_comment';
    };
    if(!file && !comment) {
      action = 'delete_file';
    };

    const formData = new FormData();
    formData.append('files[]', file);
    formData.append('user_id', user_id);
    formData.append("course_id", course_id);
    formData.append("comment", comment ? comment : '');
    formData.append("action", action);
    formData.append("workstation", JSON.stringify(workstation));
    formData.append("userLanguage", this.language);

    return fetch(url, {
      method: "POST",
      body: formData,
      headers: {
        'Authorization':`Bearer ${token}`,
        'Accept':`application/json, */*`
      }
    })
    .then( res => res.json() )
	}

	// CargarCursos(schoolsID, form) {
	// 	 let url: string = this.apiUrls.urlReporte + `filtros/schools/courses`;

	// 	 const params = {
	// 		schoolsIds: schoolsID,
	// 		// CursosActivos: form.usersStatus === "activos" || form.usersStatus === "todos" || form.usersStatus === ""  ? true : false,
	// 		// CursosInactivos: form.usersStatus === "inactivos" || form.usersStatus === "todos" ? true : false,
	// 	 };

	// 	let promesa = this.http
	// 		.post(url, JSON.stringify(params))
	// 		.toPromise()
	// 		.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
	// 		.catch((error) => Promise.reject(error));
	// 	return promesa;
	// }

  // request to report api
  getReportsToken() {
    let url: string = `${this.apiUrls.urlReporte}auth/token`;
    const secretKey = environment.REPORTS_SECRETKEY;
    return this.http.post<any>(url, {  code: secretKey } );
  }

	CargarEscuelasParaReportes(workspaceId, userID, form) {
    let params = `?escuelasActivas=${form.escuelasActivas}&escuelasInactivas=${form.escuelasInactivas}`;
		let url: string = this.apiUrls.urlReporte + `filtros/schools/${workspaceId}/${userID}${params}`;

		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	CargarCursos(schoolsID, form, supervisorId) {
		let params = `?CursosActivos=${form.CursosActivos}&CursosInactivos=${form.CursosInactivos}&supervisorId=${supervisorId}`;
		const url: string = this.apiUrls.urlReporte + `filtros/courses/${schoolsID}/all${params}`;
	    const promesa = this.http
	    .get(url)
	   	.toPromise()
	   	.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
	   	.catch((error) => Promise.reject(error));
	   return promesa;
   }

	NotasXcurso(workspaceId, supervisorId, form ) {
		console.log("form cursos",form);

	    const url: string = this.apiUrls.urlReporte + `exportar/supervisores_notas`;

	   const params = {
		workspaceId: workspaceId,
		supervisorId: supervisorId,
		escuelas: form.escuelas,
		cursos: form.cursos,
		CursosActivos: form.CursosActivos,
		CursosInactivos: form.CursosInactivos,
		status: form.resultado?.length ? form.resultado : [],
		aprobados: !form.resultado?.length || form.resultado.includes("aprobado"),
		desaprobados: !form.resultado?.length || form.resultado.includes("desaprobado"),
		desarrollo: !form.resultado?.length || form.resultado.includes("desarrollo"),
		encuestaPendiente: !form.resultado?.length || form.resultado.includes("enc_pend"),
		noIniciado: !form.resultado?.length || form.resultado.includes("pending")
	   };

		let promesa = this.http
		.post(url, JSON.stringify(params))
		.toPromise()
		.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
		.catch((error) => Promise.reject(error));
		return promesa;
	}

	CargarTemas(coursesIds, form = null) {
		let statusfilter = `?temasActivas=${form.temasActivas}&temasInactivas=${form.temasInactivas}`;
		let url: string = this.apiUrls.urlReporte + `filtros/topics/${coursesIds}`+statusfilter;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	NotasXtemas(workspaceId, supervisorId, form ) {
		console.log("form temas",form);
	    const url: string = this.apiUrls.urlReporte + `exportar/supervisores_notas_temas`;
	   const body = {
		workspaceId: workspaceId,
		supervisorId: supervisorId,
		escuelas: form.escuelas,
		cursos: form.cursos,
		temas: form.temas,
		CursosActivos: form.CursosActivos,
		CursosInactivos: form.CursosInactivos,
		revisados: !form.resultado?.length || form.resultado.includes("revisado"),
		realizados: !form.resultado?.length || form.resultado.includes("realizado"),
		porIniciar: !form.resultado?.length || form.resultado.includes("por-iniciar"),
		aprobados: !form.resultado?.length || form.resultado.includes("aprobado"),
		desaprobados: !form.resultado?.length || form.resultado.includes("desaprobado"),
	   };

		let promesa = this.http
		.post(url, JSON.stringify(body))
		.toPromise()
		.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
		.catch((error) => Promise.reject(error));
		return promesa;
	}

	AvanceUsuarios(workspaceId:number, supervisorId:number ) {
		const url: string = this.apiUrls.urlReporte + `exportar/supervisores_avance_curricula`;

		const params = {
			workspaceId: workspaceId,
			supervisorId: supervisorId
		};

		let promesa = this.http
		.post(url, JSON.stringify(params))
		.toPromise()
		.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
		.catch((error) => Promise.reject(error));
		return promesa;
	}

	/********************* / REPORTES *************************/

	/*********************  CHECKLIST *************************/
	obtenerAlumnos(alumno?, page?, estado?) {
		let url: string = this.apiUrls.serviceBaseRest + `entrenamiento/alumnos`;
		console.log(url);
		let params;
		if(page){
			params = {
				filtro:{
					usuario: alumno,
					estado: estado,
				},
				page: page
			};
		} else{
			params = {
				filtro: alumno,
			};
		}

		let promesa = this.http
			.post(url, JSON.stringify(params))
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	obtenerChecklists(checklist?, page?) {
		let url: string = this.apiUrls.serviceBaseRest + `entrenamiento/trainer/checklists`;
		let params;
		if(page){
			params = {
				filtro: {
					nombre: checklist
				},
				page: page
			};
		} else{
			params = {
				filtro: {
					nombre: checklist
				},
			};
		}
		let promesa = this.http
			.post(url, JSON.stringify(params))
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	obtenerAlumnosChecklist(checklist_id?, page?) {
		let url: string = this.apiUrls.serviceBaseRest + `entrenamiento/checklist/students`;
		let params;
		if(page){
			params = {
				page: page,
				checklist_id: checklist_id
			};
		} else{
			params = {
				checklist_id: checklist_id
			};
		}
		let promesa = this.http
			.post(url, JSON.stringify(params))
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	obtenerActividadesChecklist(checklist_id?) {
		let url: string = this.apiUrls.serviceBaseRest + `entrenamiento/checklist/${checklist_id}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	cambiarEstadoActividad(actividades, checklist_id, alumnos_id, alumnos_todos, tipo, feedback_entrador) {
			let url: string = this.apiUrls.serviceBaseRest + `entrenamiento/marcar_actividad`;
			console.log(url);

			let params = {
				actividades,
				checklist_id,
				alumnos_id,
				alumnos_todos,
				tipo,
				feedback_entrador
			};

			let promesa = this.http
				.post(url, JSON.stringify(params))
				.toPromise()
				.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
				.catch((error) => Promise.reject(error));
			return promesa;
		}

	obtenerAlumno(user_id) {
		let url: string = this.apiUrls.serviceBaseRest + `entrenamiento/checklist_alumnos/${user_id}`;
		//console.log(url);
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}


	obtenerChecklistsV3(checklist?, page?, lat?, long?, search?) {
		let ifchecklist = checklist ? checklist : '';
		let ifsearch = search ? search : '';
		let coords = '';
		if(lat && long) {
			coords = `&lat=${lat}&long=${long}`;
		}
		let filter = '?filter='+ifchecklist+'&search='+ifsearch
		let url: string = this.apiUrls.serviceBaseRest + `entrenamiento/v2/trainer/checklists` + filter + coords;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	getDataProgressChecklist(typeChecklist, rangeDates) {
		let url: string = this.apiUrls.serviceBaseRest + `entrenamiento/v2/checklists/progress?modality=${typeChecklist}&init_date=${rangeDates[0]}&final_date=${rangeDates[1]}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	getSelectedChecklistProgress(isTypeQualifyEntity, id) {
    let url: string = this.apiUrls.serviceBaseRest;
    if(isTypeQualifyEntity) {
      url += `entrenamiento/v2/checklists/progress-instance?audit_id=${id}`;
    } else {
      url += `entrenamiento/v2/checklists/progress-instance?checklist_id=${id}`;
    }
		// let url: string = this.apiUrls.serviceBaseRest + `entrenamiento/v2/checklists/progress`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	getfiltersProgressChecklist() {
		let url: string = this.apiUrls.serviceBaseRest + `entrenamiento/v2/checklists/progress-init-data`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}
	obtenerListadoAsignadosChecklist(checklist_id, search_text = '', status= '', page = 1) {
		let url: string = this.apiUrls.serviceBaseRest + `entrenamiento/v2/trainer/checklists/${checklist_id}/users?search=${search_text}&filter=${status}&page=${page}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}
	crearNuevaInstanciaChecklist(checklist, data) {
		let url: string = this.apiUrls.serviceBaseRest + `entrenamiento/v2/trainer/checklists/${checklist}/create-new-instance`;
		let promesa = this.http
			.post(url, JSON.stringify(data))
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}
	obtenerListadoEntidadesChecklist(checklist_id, search_text = '', page = 1) {
		let url: string = this.apiUrls.serviceBaseRest + `entrenamiento/v2/trainer/checklists/${checklist_id}/list-entities?search=${search_text}&page=${page}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	revisarActividadChecklist(checklist, data, action_request, entity_id?, isInduction = false) {
		entity_id = entity_id ? entity_id : '';
    action_request = action_request ? action_request : '';
		let url: string = this.apiUrls.serviceBaseRest + `entrenamiento/v2/trainer/checklists/${checklist}/save_activity?action_request=${action_request}&entity_id=${entity_id}`;
		if(isInduction) {
      url += `&platform=induction`
    }
    let promesa = this.http
			.post(url, JSON.stringify(data))
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

  sendActivityVideo(checklist, data, action_request, entity_id?, isInduction = false) {
    entity_id = entity_id ? entity_id : '';
    action_request = action_request ? action_request : '';
	  let url: string = this.apiUrls.serviceBaseRest + `entrenamiento/v2/trainer/checklists/${checklist}/save_activity?action_request=${action_request}&entity_id=${entity_id}`;
    if(isInduction) {
      url += `&platform=induction`
    }
    const token: string = localStorage.getItem("token");
    let data_usuario = JSON.parse(localStorage.getItem("user_data"));

    const workstation = {
      platform: data_usuario?.onboarding ? "onboarding" : "training",
      platform_id: data_usuario?.current_platform?.id,
      workspace: data_usuario?.workspace?.slug,
      workspace_id: data_usuario?.workspace?.id,
      subworkspace: data_usuario?.module?.slug,
      subworkspace_id: data_usuario?.module?.id,
    }

    // const fileName = `video_${Date.now()}.mp4`;

    const formData = new FormData();
    formData.append('activity_id', data.activity_id);
    formData.append('qualification_id', data.qualification_id);
    formData.append('qualification_response', data.qualification_response);
    formData.append('user_ids',  JSON.stringify(data.user_ids) );
    formData.append('action', data.action);
    formData.append('photo', data.photo);
    formData.append('file_photo', data.file_photo);
    formData.append('entity_id', data.entity_id);
    formData.append('from', data.from);
    formData.append('datetime', data.datetime);
    formData.append('file_video', data.file_video.video, data.file_video.fileName);

    formData.append("workstation", JSON.stringify(workstation));
    formData.append("userLanguage", this.language);

    return fetch(url, {
      method: "POST",
      body: formData,
      headers: {
        'Authorization':`Bearer ${token}`,
        'Accept':`application/json, */*`
      }
    })
    .then( res => res.json() )
	}

	guardarPlanAccion(checklist, data, entity_id?) {
		entity_id = entity_id ? entity_id : '';
		let url: string = this.apiUrls.serviceBaseRest + `entrenamiento/v2/checklist/${checklist}/save_action_plan?entity_id=${entity_id}`;
		let promesa = this.http
			.post(url, JSON.stringify(data))
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	obtenerChecklistAndActivitiesV3(checklist_id, area_id?, user_id?, entity_id?, is_multiple = false, isInduction = false) {
		area_id = area_id ? JSON.stringify(area_id) : '';
		user_id = user_id ? user_id : '';
		entity_id = entity_id ? entity_id : '';
		let url: string = this.apiUrls.serviceBaseRest + `entrenamiento/v2/trainer/checklists/${checklist_id}/activities?theme_id=${area_id}&user_id=${user_id}&entity_id=${entity_id}&multiple=${is_multiple}`;
    if(isInduction) {
      url += `&platform=induction`
    }
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}
	obtenerResultadosChecklist(checklist_id, data) {
		let url: string = this.apiUrls.serviceBaseRest + `entrenamiento/v2/trainer/checklists/${checklist_id}/results`;
		let promesa = this.http
			.post(url, JSON.stringify(data))
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}
	sendMailChecklist(checklist_id, data) {
		let url: string = this.apiUrls.serviceBaseRest + `entrenamiento/v2/trainer/checklists/${checklist_id}/send-results`;
		let promesa = this.http
			.post(url, JSON.stringify(data))
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}
	obtenerListaTemasYAreas(checklist_id, search?, user_id?, entity_id?) {
		search = search ? search : '';
		user_id = user_id ? user_id : '';
		entity_id = entity_id ? entity_id : '';
		let url: string = this.apiUrls.serviceBaseRest + `entrenamiento/v2/checklist/${checklist_id}/list-themes?user_id=${user_id}&entity_id=${entity_id}&search=${search}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	verificarVistaComputacional(activity, data_image, entityID, usersSelectedList) {
		let url: string = this.apiUrls.serviceBaseRest + `entrenamiento/v2/activity/${activity}/verify_photo?entity_id=${entityID}`;
		let promesa = this.http
			.post(url, JSON.stringify({
				'upload_image': data_image,
        user_ids: usersSelectedList
			}))
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	finalizarChecklist(checklist, activity) {
		let url: string = this.apiUrls.serviceBaseRest + `entrenamiento/v2/checklist/${checklist}/save_activities`;
		let promesa = this.http
			.post(url, JSON.stringify(activity))
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	guardarFirmaSupervisado(checklist, data, user_id?, entity_id?) {
		user_id = user_id ? user_id : '';
		entity_id = entity_id ? entity_id : '';
		let url: string = this.apiUrls.serviceBaseRest + `entrenamiento/v2/checklist/${checklist}/save_signature_supervised?user_id=${user_id}&entity_id=${entity_id}`;
		let promesa = this.http
			.post(url, JSON.stringify(data))
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	getListSupervised(checklist, entity_id, page, search?) {
    search = search ? search : ''
		let url: string = this.apiUrls.serviceBaseRest + `entrenamiento/v2/checklist/${checklist}/${entity_id}/list-supervised?page=${page}&search=${search}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;

	}
	requiredGeolocalizationChecklistsV3() {
		let url: string = this.apiUrls.serviceBaseRest + `entrenamiento/v2/trainer/init-data`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	/********************* / CHECKLIST *************************/

	/*********************  VIDEOTECA *************************/

	obtenerCategorias() {
		let url: string = this.apiUrls.serviceBaseRest + `videoteca/get-selects`;
		console.log(url);
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	obtenerVideoteca(palabra?, cat_id?, num_page?) {
		let text_cat = "";
		let text_palabra = "";
		let text_num_page = "";

		if (palabra) text_palabra = palabra;
		if (cat_id) text_cat = `&categoria_id=${cat_id}`;
		if (num_page) text_num_page = `&page=${num_page}`;

		let url: string =
			this.apiUrls.serviceBaseRest +
			`videoteca/search?q=${text_palabra + text_cat + text_num_page}`;
		console.log(url);
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	obtenerMedia(id_videoteca) {
		let url: string = this.apiUrls.serviceBaseRest + `videoteca/show/${id_videoteca}`;
		console.log(url);
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	agregarVisita(id_videoteca) {
		let url: string = this.apiUrls.serviceBaseRest + `videoteca/store-visit/${id_videoteca}`;
		let promesa = this.http
			.post(url, {})
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	obtenerRelacionados(id_videoteca, page) {
		let text_num_page = "";
		if (page) text_num_page = `?page=${page}`;

		let url: string =
			this.apiUrls.serviceBaseRest + `videoteca/related/${id_videoteca + text_num_page}`;
		console.log(url);
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	obtenerRelacionadosXtag(video_actual, tag_id, page) {
		let text_num_page = "";
		if (page) text_num_page = `&page=${page}`;

		let url: string =
			this.apiUrls.serviceBaseRest +
			`videoteca/search?no_id=${video_actual}&tag=${tag_id + text_num_page}`;
		console.log(url);
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	/********************* / VIDEOTECA *************************/

	/********************* GLOSARIO *************************/

	//Carga el glosario
	cargar_glosario(lab_id, cat_id, prin_act, palabra, page) {
		let text_act = "";
		let text_cat = "";
		let text_lab = "";
		let text_page = "";
		let index = 0;

		if (prin_act) {
			prin_act.forEach((e) => {
				text_act = text_act + "&principios_activos[" + index + "]=" + e.id;
				index++;
			});
		}
		if (lab_id) text_lab = "&laboratorio_id=" + lab_id;
		if (cat_id) text_cat = "&categoria_id=" + cat_id;
		if (page) text_page = "&page=" + page;
		let url: string =
			this.apiUrls.serviceBaseRest +
			"glosario/search" +
			"?q=" +
			palabra +
			text_lab +
			text_cat +
			text_act +
			text_page;
		// console.log(url);
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	filtros_glosario() {
		let url: string = this.apiUrls.serviceBaseRest + "glosario/selects";
		console.log(url);
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	/********************* / GLOSARIO *************************/

	/********************* VADEMECUM *************************/
	obtenerScorms(palabra?, cat_id?, subcat_id?: any, num_page?) {
		let text_cat = "";
		let text_subcat = "";
		let text_palabra = "";
		let text_num_page = "";

		if (palabra) text_palabra = palabra;
		if (cat_id) text_cat = `&category_id=${cat_id}`;
		if (subcat_id.length > 0) text_subcat = `&subcategory_id=${subcat_id}`;
		if (num_page) text_num_page = `&page=${num_page}`;

		let url: string =
			this.apiUrls.serviceBaseRest +
			`vademecum/search?q=${text_palabra + text_cat + text_subcat + text_num_page}`;
		// console.log(url);
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	categoriasScorms() {
		let url: string = this.apiUrls.serviceBaseRest + "vademecum/selects";
		// console.log(url);
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	subCategoriasScorms(categoria_id) {
		let url: string = this.apiUrls.serviceBaseRest + `vademecum/subcategorias/${categoria_id}`;
		// console.log(url);
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	visitaScorm(scorm_id) {
		let url: string = this.apiUrls.serviceBaseRest + `vademecum/store-visit/${scorm_id}`;
		console.log(url);
		let promesa = this.http
			.post(url, JSON.stringify({}))
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}
	/********************* / VADEMECUM *************************/

	/********************* AULAS VIRTUALES *************************/
	getReuniones(status, num_page?) {
		let text_num_page = "";
		if (num_page) text_num_page = `&page=${num_page}`;

		let url: string =
			this.apiUrls.serviceBaseRest + `meetings/list?code=${status + text_num_page}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	getStatusReuniones() {
		let url: string = this.apiUrls.serviceBaseRest + `courses-in-person/get-data`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	empezarReunion(meeting_id) {
		let url: string = this.apiUrls.serviceBaseRest + `meetings/${meeting_id}/start`;
		let promesa = this.http
			.post(url, {})
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		console.log(promesa);
		return promesa;
	}

	unirseReunion(meeting_id) {
		let url: string = this.apiUrls.serviceBaseRest + `meetings/${meeting_id}/join`;
		let promesa = this.http
			.post(url, {})
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		console.log(promesa);
		return promesa;
	}

	finalizarReunion(meeting_id) {
		let url: string = this.apiUrls.serviceBaseRest + `meetings/${meeting_id}/finish`;
		let promesa = this.http
			.post(url, {})
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		console.log(promesa);
		return promesa;
	}

	getAttendants(filter) {
		let url: string = this.apiUrls.serviceBaseRest + `meetings/search-attendants`;
		let params: HttpParams = filter;
		console.log(params);
		let promesa = this.http
			.get(url, { params })
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		console.log(promesa);
		return promesa;
	}

	getGroups() {
		let url: string = this.apiUrls.serviceBaseRest + `meetings/get-form-data`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		console.log(promesa);
		return promesa;
	}

	createReunion(data) {
		let url: string = this.apiUrls.serviceBaseRest + `meetings/store`;
		let promesa = this.http
			.post(url, data)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		console.log(promesa);
		return promesa;
	}

	editReunion(meeting_id) {
		let url: string = this.apiUrls.serviceBaseRest + `meetings/${meeting_id}/edit`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		console.log(promesa);
		return promesa;
	}

	updateReunion(meeting_id, data) {
		let url: string = this.apiUrls.serviceBaseRest + `meetings/${meeting_id}/update`;
		let promesa = this.http
			.put(url, data)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		console.log(promesa);
		return promesa;
	}

	duplicateReunion(meeting_id) {
		let url: string = this.apiUrls.serviceBaseRest + `meetings/${meeting_id}/duplicate-data`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		console.log(promesa);
		return promesa;
	}

	subirExcel(data) {
		let url: string = this.apiUrls.serviceBaseRest + `meetings/upload-attendants`;
		let promesa = this.http
			.post(url, data)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		console.log(promesa);
		return promesa;
	}

	cancelarReunion(meeting_id) {
		let url: string = this.apiUrls.serviceBaseRest + `meetings/${meeting_id}/cancel`;
		let promesa = this.http
			.put(url, {})
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		console.log(promesa);
		return promesa;
	}

	deletedReunion(meeting_id) {
		let url: string = this.apiUrls.serviceBaseRest + `meetings/${meeting_id}/destroy`;
		let promesa = this.http
			.delete(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		console.log(promesa);
		return promesa;
	}
	/********************* / AULAS VIRTUALES *************************/

	/********************* CURSOS PRESENCIALES *************************/

	getInPersonCourses(dateFilter,typeSessionFilter, num_page?) {
		let text_num_page = "";
		if (num_page) text_num_page = `&page=${num_page}`;
		let paramType = "";
		if (typeSessionFilter) paramType = `&type_session=${typeSessionFilter}`;


		let url: string = this.apiUrls.serviceBaseRest + `courses-in-person/list?code=${dateFilter + paramType + text_num_page}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	getActiveOptions(idTopic) {
		let url: string = this.apiUrls.serviceBaseRest + `courses-in-person/topic/${idTopic}/menu`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}
	getInPersonCourseData(idTopic) { //courses-in-person/topic/{topic}
		let url: string = this.apiUrls.serviceBaseRest + `courses-in-person/topic/${idTopic}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	validateAttendanceMethod(idTopic, validationType) {
		let url: string = this.apiUrls.serviceBaseRest + `courses-in-person/topic/${idTopic}/validate-resource?type=${validationType}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}
	finishSessionMethod(idTopic) {
		let url: string = this.apiUrls.serviceBaseRest + `courses-in-person/topic/${idTopic}/session-finished`;
		let promesa = this.http
			.post(url, {})
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	multimediaIsAvailableMethod(idTopic, validationType) {
		let url: string = this.apiUrls.serviceBaseRest + `courses-in-person/topic/${idTopic}/validate-resource?type=${validationType}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}
	validateAvailableExamMethod(idTopic, validationType) {
		let url: string = this.apiUrls.serviceBaseRest + `courses-in-person/topic/${idTopic}/validate-resource?type=${validationType}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}
	validateAvailableSurveyMethod(idTopic, validationType) {
		let url: string = this.apiUrls.serviceBaseRest + `courses-in-person/topic/${idTopic}/validate-resource?type=${validationType}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	setSurveyActiveMethod(idTopic) {
		let url: string = this.apiUrls.serviceBaseRest + `courses-in-person/topic/${idTopic}/start-poll`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	sendSignatureOfCourseAttendance(canvaImgData, topicID) {
    const body = {
      signature: canvaImgData
    }
		let url: string = this.apiUrls.serviceBaseRest + `courses-in-person/topic/${topicID}/upload-signature`;
		const token: string = localStorage.getItem("token");

    let promesa = this.http
    .post(url, body)
    .toPromise()
    .then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
    .catch((error) => Promise.reject(error));
    return promesa;
	}

	getInPersonMultimedia(courseID, topicID) {
		let url: string = this.apiUrls.serviceBaseRest + `courses-in-person/course/${courseID}/topic/${topicID}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	getAttendanceList(courseID, topicID, attendanceCode, query) {
		let queryStr = "";
		//&search_user=Flor
		if (query) queryStr = `&search_user=${query}`;
		// course/{course_id}/topic/{topic_id}/assigned?code=present  (code = all,  pending,  present)
		let url: string = this.apiUrls.serviceBaseRest + `courses-in-person/course/${courseID}/topic/${topicID}/assigned?code=${attendanceCode + queryStr}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}
	getQR(topicID) {
		let url: string = this.apiUrls.serviceBaseRest + `courses-in-person/topic/${topicID}/users-init-data`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	postAttendanceOfUsers(courseID, usersID, action) {
		// Post: api/rest/courses-in-person/topic/{course_id}/take-assistance
		// Estructura: {
		// 	"user_ids":[17,55,56],
		// 	"action":"late"
		// }
		//- action (late,absent,attended)
		let url: string = this.apiUrls.serviceBaseRest + `courses-in-person/topic/${courseID}/take-assistance`;

		let body = {
			user_ids: usersID,
			action: action,
		};

		let promesa = this.http
			.post(url, body)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	getEvaluationStatus(topicID) {
		let url: string = this.apiUrls.serviceBaseRest + `courses-in-person/topic/${topicID}/verify-evaluation-time`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	postExamData(topicID, action, time) {
		// Post: api/rest/courses-in-person/topic/{course_id}/take-assistance
		// Estructura: {
		// 	"user_ids":[17,55,56],
		// 	"action":"late"
		// }
		//- action (late,absent,attended)
		let url: string = this.apiUrls.serviceBaseRest + `courses-in-person/topic/evaluation`;

		let body = {
			topic_id: topicID,
			action: action,
			time: time
		};

		let promesa = this.http
			.post(url, body)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	/********************* /CURSOS PRESENCIALES *************************/

	/********************* HISTORICO *************************/
	listarWorkspaceHistorico(){
		let url: string = this.apiUrls.serviceBaseRest + `reports/user-history-filters`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;

	}

	//api/rest/reports/user-history/:schoolId
	listarCursosHistorico( WorkspaceId ,schoolId?, searchValue?, page? ){
		let textWorkspaceId = "";
		let textSchoolId = "";
		let textSearch = "";
		let textPage = "";
		if (WorkspaceId) textWorkspaceId =`${WorkspaceId}`;
		if (schoolId) textSchoolId =`/${schoolId}`;
		// if (page) textPage =`&page=${page}`;
		if (page) textPage =`?page=${page}`;
		if (searchValue && !page) textSearch = `?search=${searchValue}`;
		if (searchValue && page) textSearch = `&search=${searchValue}`;
		let url: string = this.apiUrls.serviceBaseRest + `reports/user-history/${ textWorkspaceId + textSchoolId + textPage + textSearch }`;
		//reports/user-history/{workspaceId?}/{schoolId?}
		// let url: string = this.apiUrls.serviceBaseRest + `reports/user-history/${textSchoolId + textPage + textSearch }`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;

	}

	/********************* / HISTORICO *************************/


	/********************* NOTIFICACIONES *************************/

	ObtenerNotificaciones(num_page?) {
		let text_num_page = "";
		if (num_page) text_num_page = `?page=${num_page}`;

		let url: string = this.apiUrls.serviceBaseRest + `notification_user${text_num_page}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	RevisarNotificaciones(notificaciones_id) {
		let url: string = this.apiUrls.serviceBaseRest + `read_notification_user`;

		let promesa = this.http
			.post(url, notificaciones_id)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}
	/********************* / NOTIFICACIONES *************************/

	/********************* AYUDA FORMULARIO  *************************/

	guardarAyuda(form, skipAuthRedirect = false) {
		let url: string = this.apiUrls.serviceBaseRest + "registra_ayuda";
		console.log(url);

		let promesa = this.http
			.post(url, form, this.scormPlaybackOptions(skipAuthRedirect))
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	// Inducción tiene sus propias opciones; responde { data: { preguntas } }
	obtenerOpsAyudaInduction() {
		let url: string = this.apiUrls.serviceBaseRest + "onboarding/help-form";

		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	obtenerOpsAyuda() {
		let url: string = this.apiUrls.serviceBaseRest + "preguntas_seccion_ayuda";
		console.log(url);

		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	/********************* / AYUDA FORMULARIO  *************************/


	/********************* ADJUNTAR ARCHIVO  *************************/

	adjuntarArchivo(file:File, description:string) {
		let url: string = this.apiUrls.serviceBaseRest + "usuario_upload_file";
		const token: string = localStorage.getItem("token");
    let data_usuario = JSON.parse(localStorage.getItem("user_data"));

    const workstation = {
      platform: data_usuario?.onboarding ? "onboarding" : "training",
      platform_id: data_usuario?.current_platform?.id,
      workspace: data_usuario?.workspace?.slug,
      workspace_id: data_usuario?.workspace?.id,
      subworkspace: data_usuario?.module?.slug,
      subworkspace_id: data_usuario?.module?.id,
    }
		//Create form data
		const formData = new FormData();

		formData.append('file', file);
		formData.append('description', description);

    formData.append("workstation", JSON.stringify(workstation));


		//*************************** */

		//POST request using fetch() because http request doesn´t work
		return fetch(url, {
			// Adding method type
			method: "POST",
			// Adding body or contents to send
			body: formData,
			// Adding headers to the request
			headers: {
				'Authorization':`Bearer ${token}`,
				'Accept':`application/json, */*`
			}
		}).then( res => res.json())

		//****************************** */

		// let promesa = this.http
		// .post(url, formData)
		// .toPromise()
		// .then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
		// .catch((error) => Promise.reject(error));
		// return promesa;

	}

	/********************* / ADJUNTAR ARCHIVO*************************/

	/********************* TAREAS *************************/

	getTaskData(taskID) {
		let url = this.apiUrls.serviceBaseRest + `tareas/${taskID}/search`;
		return this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
	}

	/**
	 * `signature` milestone (phase 5d). Typed Observables, as `obtenerRutaCurso` is: the view needs the
	 * 404/422 bodies (`msg`), which `toPromise()` would hide. The signature is made once.
	 */
	getFirmaProyecto(project_id: number | string) {
		return this.http.get<FirmaProyectoResponse>(this.apiUrls.serviceBaseRest + `tareas/${project_id}/firma`);
	}

	firmarProyecto(project_id: number | string, signature: string) {
		return this.http.post<FirmarProyectoResponse>(
			this.apiUrls.serviceBaseRest + `tareas/${project_id}/firma`,
			{ signature }
		);
	}

	getTaskSummary() {
		let url = this.apiUrls.serviceBaseRest + `tareas/summary`;
		return this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
	}

	getTasksData(tasksStatus, school_id, course) {
		let url = this.apiUrls.serviceBaseRest + `tareas/user/${tasksStatus}`;
		if (school_id && school_id != '' && course && course != '') url = url + `?school_id=${school_id}`+ `&course=${course}`
		else {
			if (school_id && school_id != '') url = url + `?school_id=${school_id}`;
			if (course && course != '') url = url + `?course=${course}`;
		}
		return this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
	}

	taskUpdate(id_task, formData) {
		let url: string =  this.apiUrls.serviceBaseRest + `tareas/${id_task}/store-update`;
		const token: string = localStorage.getItem("token");
    let data_usuario = JSON.parse(localStorage.getItem("user_data"));

    const workstation = {
      platform: data_usuario?.onboarding ? "onboarding" : "training",
      platform_id: data_usuario?.current_platform?.id,
      workspace: data_usuario?.workspace?.slug,
      workspace_id: data_usuario?.workspace?.id,
      subworkspace: data_usuario?.module?.slug,
      subworkspace_id: data_usuario?.module?.id,
    }

    formData.append("workstation", JSON.stringify(workstation));

	   return fetch(url, {
		method: "POST",
		body: formData,
		headers: {
			'Authorization':`Bearer ${token}`,
			'Accept':`application/json, */*`
		}
	}).then( res => res.json())

   }

	/********************* / TAREAS *************************/

	/********************* EXTRAS *************************/

	// Funcion para Listar Encuestas libres
	lista_enc_libres() {
		// let url = this.apiUrls.serviceBaseRest + "lista_enc_libres/" + config_id;
		let url = this.apiUrls.serviceBaseRest + "lista_enc_libres";
		// console.log(url);
		return this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
	}

	verificar_versiones() {
		let url: string = this.apiUrls.serviceBaseRest + "app_versions";
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((res) => Promise.resolve(JSON.parse(JSON.stringify(res))))
			.catch((err) => Promise.reject(err));
		return promesa;
	}


	// Preguntas frecuentes
	cargarFaqs() {
		return new Promise((resolve, reject) => {
			this.http
				.get(this.apiUrls.serviceBaseRest + "preguntas_frecuentes")
				.toPromise()
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}

	subir_link(user_id: string, link: string, descripcion: string) {
		let url: string = this.apiUrls.serviceBaseRest + "usuario_upload_link";
		console.log(url);
		let params = new URLSearchParams();
		params.append("usuario_id", user_id.toString());
		params.append("link", link.toString());
		params.append("description", descripcion.toString());

		let promesa = this.http
			.post(url, params)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	listNPS(platform: string, version: string, dni: any) {
		let url: string = environment.SERVICE_BASE_REST_MASTER+'encuesta/listar?plataforma='+platform+'&version='+version+'&dni='+dni;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	sendNPS(body) {
		 let url: string =  environment.SERVICE_BASE_REST_MASTER+'encuesta/guardar';

		let promesa = this.http
			.post(url, body)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	revisarContenido(tema_id, media_id, data, skipAuthRedirect = false) {
		let promesa = this.http
		.post(this.apiUrls.serviceBaseRest+ `temas/actividad_contenido_revisado/${tema_id}/${media_id}`, data, this.scormPlaybackOptions(skipAuthRedirect))
			.toPromise()
			.then((res) => Promise.resolve(JSON.parse(JSON.stringify(res))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	duracionContenido(tema_id, media_id, data, skipAuthRedirect = false) {
		return new Promise((resolve, reject) => {
			this.http
				.post(this.apiUrls.serviceBaseRest + `temas/actividad_contenido_duracion/${tema_id}/${media_id}`, data, this.scormPlaybackOptions(skipAuthRedirect))
				.toPromise()
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}

	/**
	 * Obtiene el archivo de configuración (config-audio.json) de un contenido
	 * tipo "podcast". La URL absoluta llega en media.value y contiene la
	 * metadata del podcast y el array "sections" (episodios).
	 */
	getPodcastConfig(url) {
		// rawHttp: sin interceptors → GET simple sin headers custom → sin preflight CORS.
		let promesa = this.rawHttp
			.get(url)
			.toPromise()
			.then((res) => Promise.resolve(JSON.parse(JSON.stringify(res))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	/*********************  BENEFICIOS *************************/
	listarBeneficios(filtro?, page?, estado?, type?) {
		let url: string = this.apiUrls.serviceBaseRest + `benefits`;
		let params;
		if(page){
			params = {
				filtro:filtro,
				page: page,
				status: estado,
				type
			};
		} else{
			params = {
				filtro: filtro,
				status: estado,
				type
			};
		}

		let promesa = this.http
			.post(url, JSON.stringify(params))
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));

		return promesa;
	}

	obtenerBeneficio(id) {
		let url: string = this.apiUrls.serviceBaseRest + `benefits/${id}/show`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	registrarBeneficio(benefit, type) {
		let url: string = this.apiUrls.serviceBaseRest + `benefits/register`;

		let params = {
			benefit,
			type
		};

		let promesa = this.http
			.post(url, JSON.stringify(params))
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	obtenerSpeaker(id) {
		let url: string = this.apiUrls.serviceBaseRest + `benefits/speakers/${id}/show`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	listarFiltros() {
		let url: string = this.apiUrls.serviceBaseRest + `benefits/config`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	registrarEncuesta(benefit) {
		let url: string = this.apiUrls.serviceBaseRest + `benefits/polls/register`;
		let params = {
			benefit,
		};
		let promesa = this.http
			.post(url, JSON.stringify(params))
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	actualizarEmail(email) {
		let url: string = this.apiUrls.serviceBaseRest + `actualizar_correo`;
		let params = {
			email,
		};
		let promesa = this.http
			.post(url, JSON.stringify(params))
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	/********************* / EXTRAS *************************/


	/********************* MODULO DE RECONOCIMIENTO *************************/
	getCampaignsData(userId) {
		let url: string = this.apiUrls.serviceBase + `rest/votaciones/campaigns/${userId}`;

		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	getCampaignsContentsData(campaignId) {
		let url: string = this.apiUrls.serviceBase + `rest/votaciones/campaign/v2/contents/${campaignId}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}
	//todo: verificar-----------
	campaignContentsCheckReview(campaignID, contentID) {
		let url: string = this.apiUrls.serviceBase + `rest/votaciones/campaign/check-content/${campaignID}/${contentID}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	getCampaignsRequirements(campaignId, userId) {
		let url: string = this.apiUrls.serviceBase + `rest/votaciones/campaign/requirements/${campaignId}/${userId}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}
	getUserBadges(campaignId, userId) {
		localStorage.removeItem("campaignBadges");
		let url: string = this.apiUrls.serviceBase + `rest/votaciones/campaign/badges/${campaignId}/${userId}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	postSurveyAnswer(campaignId, userId, answer) {
		let body = {
			campaign_id: campaignId,
   			user_id: userId,
   			answer: answer
		}
		return new Promise((resolve, reject) => {
			this.http
				.post(this.apiUrls.serviceBaseRest + `votaciones/campaign/contents/send_answer`, body)
				.toPromise()
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}

	getAnswerStatus(campaignId, userId) {
		let url: string = this.apiUrls.serviceBaseRest + `votaciones/campaign/check/user_answer/${campaignId}/${userId}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	campaignBadges(campaignId, userId) {
		let url: string = this.apiUrls.serviceBaseRest + `votaciones/campaign/badges/${campaignId}/${userId}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	getCoworkersListData(requirements,campaignID, userID, query, page, stateFilter) {
		const filter = stateFilter === null ? "" : stateFilter;
		let url:string;
		if(requirements) {
			//requirements.id  requirements.criterion_id
			url = this.apiUrls.serviceBaseRest + `votaciones/campaign/postulation/${campaignID}/${userID}?criterio_id=${requirements.criterion_id}&criterio_value_id=${requirements.id}&q=${query}&page=${page}&paginate=&active=${filter}`;
		} else {
			url = this.apiUrls.serviceBaseRest + `votaciones/campaign/postulation/${campaignID}/${userID}?criterio_id=&criterio_value_id=&q=${query}&page=${page}&paginate=&active=${filter}`;
		}

		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	postSustentMessage(summonedId, userId, message) {
		let body = {
			summoned_id: summonedId,
   			user_id: userId,
   			sustent: message,
		}
		return new Promise((resolve, reject) => {
			this.http
				.post(this.apiUrls.serviceBaseRest + `votaciones/campaign/postulation/send_sustent`, body)
				.toPromise()
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}

	checkPostulates(campaignId, userId) {
		let url: string = this.apiUrls.serviceBaseRest + `votaciones/campaign/check/user_postulate/${campaignId}/${userId}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	getCandidatesListData(requirements,campaignID, userID, query, page) {
		let url:string;
		if(requirements) {
			url = this.apiUrls.serviceBaseRest + `votaciones/campaign/votation/candidates/${campaignID}/${userID}/${requirements.criterion_id}?criterio_value_id=${requirements.id}&q=${query}&page=${page}&paginate=`;
		} else {
			//CONFIRMAR EN CASO NO LLEGUE REQUERIMIENTOS EN ETAPA DE VOTACIÓN
			url = this.apiUrls.serviceBaseRest + `votaciones/campaign/votation/candidates/${campaignID}/${userID}/0?criterio_value_id=&q=${query}&page=${page}&paginate=`;
		}

		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	getCandidatesAlreadyVotedListData(campaignId, userID) {
		let url = this.apiUrls.serviceBaseRest + `votaciones/campaign/votation/user_votes/${campaignId}/${userID}?page=1&paginate=`;

		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	postVotes(candidates_ids, userId) {
		let body = {
			candidates_ids: candidates_ids,
   			user_id: userId,
		}
		return new Promise((resolve, reject) => {
			this.http
				.post(this.apiUrls.serviceBaseRest + `votaciones/campaign/votation/send_votes`, body)
				.toPromise()
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}


	/********************* / MODULO DE RECONOCIMIENTO *************************/

	/**************** NOTIFICACIONES  **************************/
	listNotifications(currentPage: number, status: string = 'all', modality: string = '') {
		let url: string = this.apiUrls.serviceBase + `users/v2/notifications?page=${currentPage}&status=${status}`;
		if (modality) {
			url += `&modality=${modality}`;
		}
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}
	hideNotification(id, hide) {
		let url: string = this.apiUrls.serviceBase + `users/notification/${id}`;
		let body = { hide: hide }
		let promesa = this.http
			.put(url, body)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}
	markAsReadNotification(id, markAsRead) {
		let url: string = this.apiUrls.serviceBase + `users/notification/${id}`;
		let body = { markAsRead: markAsRead }
		let promesa = this.http
			.put(url, body)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}
	/**************** NOTIFICACIONES  **************************/

	/**************** INVITADOS  **************************/

	verifyGuestUrlMultimarca(cod) {
		let url: string = environment.URL_MASTER + `/api/verify_guest_url_multimarca/${cod}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	verifyGuestUrl(cod) {
		let url: string = this.apiUrls.serviceBaseRest + `verify-guest-url`;
		let params = new HttpParams().set('code', cod);
		let promesa = this.http
			.get(url, { params })
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	sendCodeGuest(email, name, lastname, document, recaptchaToken) {
		let url: string = this.apiUrls.serviceBaseRest + `send-code-guest`;
		let body = { email, name, lastname, document, "g-recaptcha-response": recaptchaToken }
		let promesa = this.http
			.post(url, body)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	verifyCodeGuest(email, code, recaptchaToken) {
		let url: string = this.apiUrls.serviceBaseRest + `verify-code-guest`;
		let body = { email, code, "g-recaptcha-response": recaptchaToken }
		let promesa = this.http
			.post(url, body)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	childCriterioValues(workspace_id, criterio_id, criterio_value_id) {
		let url: string = this.apiUrls.serviceBaseRest + `child-criterion-values`;
		let params = new HttpParams()
			.set('workspace_id', workspace_id)
			.set('criterion_id', criterio_id)
			.set('criterion_value_id', criterio_value_id);
		let promesa = this.http
			.get(url, { params })
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	storeGuest(workspace_id, code_id, guest_id, body) {
		let url: string = this.apiUrls.serviceBaseRest + `store-guest`;
		let params = new HttpParams()
			.set('workspace_id', workspace_id)
			.set('code_id', code_id);
		if (guest_id) {
			params = params.set('guest_id', guest_id);
		}
		let promesa = this.http
			.post(url, body, { params })
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}
	/**************** INVITADOS  **************************/

	/**************** INDUCCIÓN  **************************/

	// User

	getProcessDataInstructions(process_id) {
		let url: string = this.apiUrls.serviceBaseRest + `onboarding/user/processes/${process_id}/data/instructions`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	getProcessDataInstructionsSave(process_id) {
		let url: string = this.apiUrls.serviceBaseRest + `onboarding/user/processes/${process_id}/data/instructions/save`;
		let promesa = this.http
			.post(url,'')
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	getProcessDataActivities(process_id) {
		let url: string = this.apiUrls.serviceBaseRest + `onboarding/user/processes/${process_id}/data`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

  sendSignatureActivityMethod(canvaImgData,processId, activity_id, model_id) {
    const body = {
      signature: canvaImgData,
      activity_id: activity_id,
      model_id: model_id
    }
		const token: string = localStorage.getItem("token");
    let url: string = this.apiUrls.serviceBaseRest + `onboarding/user/processes/${processId}/activity/register`;

    let promesa = this.http
    .post(url, body)
    .toPromise()
    .then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
    .catch((error) => Promise.reject(error));
    return promesa;

	}

  getDocumentToSign(processID,activityID) {
    //{{base_url}}processes/32/activity/firmas/216
    let url: string = this.apiUrls.serviceBaseRest + `processes/${processID}/activity/firmas/${activityID}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
  }

	// Lider (mentor)

	getPasantiasData() {
		let url: string = this.apiUrls.serviceBaseRest + `onboarding/pasantias-asignadas`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	getPasantiaData(process_id, page, estado) {
		let url: string = this.apiUrls.serviceBaseRest + `onboarding/pasantias-asignadas/${process_id}/data?page=${page}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;

	}

	getInfoPasantiaUser(user_id, pasantia_id) {
		let url: string = this.apiUrls.serviceBaseRest + `onboarding/pasantia-user-info`;
		let params = {
			user_id,
			internship_id: pasantia_id
		};
		let promesa = this.http
			.post(url, JSON.stringify(params))
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	saveInfoPasantiaUser(params) {
		let url: string = this.apiUrls.serviceBaseRest + `onboarding/pasantia-user-info/save`;
		let promesa = this.http
			.post(url, JSON.stringify(params))
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	// Supervisor

	getProcessesData() {
		let url: string = this.apiUrls.serviceBaseRest + `onboarding/supervisor/processes`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	getProcessData(process_id) {
		let url: string = this.apiUrls.serviceBaseRest + `onboarding/supervisor/processes/${process_id}/data`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;

	}

	getProcessDataStudents(process_id, page, query, filterBy?) {
		// let url: string = this.apiUrls.serviceBaseRest + `onboarding/supervisor/processes/${process_id}/data/students?page=${page}`;
    // if(query) {
    //   url += `&q=${query}`
    // };

    const url = `${this.apiUrls.serviceBaseRest}onboarding/supervisor/processes/${process_id}/data/students`;

    let params = new HttpParams().set('page', page);
    if (query) {
      params = params.set('q', query);
    };
    if (filterBy) {
      params = params.set('filter', filterBy);
    };

    // if (pendingChecklist) {
      // params = params.set('filterBy', "test");
    // }

		let promesa = this.http
			.get(url, { params })
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	getProcessDataSupervisors(process_id) {
		let url: string = this.apiUrls.serviceBaseRest + `onboarding/supervisor/processes/${process_id}/data/supervisors`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;

	}

	getInfoStudent(user_id) {
		let url: string = this.apiUrls.serviceBaseRest + `onboarding/supervisor/processes/info_student/${user_id}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	getUsersAbsencesMassive() {
		let url: string = this.apiUrls.serviceBaseRest + `onboarding/supervisor/processes/users_absences_massive`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;

	}

	saveAttendance(process_id, params) {
		let url: string = this.apiUrls.serviceBaseRest + `onboarding/supervisor/processes/${process_id}/save_attendance`;
		let promesa = this.http
			.post(url, JSON.stringify(params))
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	saveAttendanceMassive(params) {
		let url: string = this.apiUrls.serviceBaseRest + `onboarding/supervisor/processes/save_attendance_massive`;
		let promesa = this.http
			.post(url, JSON.stringify(params))
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	// Activities

	getActivityTopic(process_id, topic_id){
		let url: string = this.apiUrls.serviceBaseRest + `onboarding/user/processes/${process_id}/activity/topic/${topic_id}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	getActivityMeeting(process_id, meeting_id){
		let url: string = this.apiUrls.serviceBaseRest + `onboarding/user/processes/${process_id}/activity/meeting/${meeting_id}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	getActivityPoll(process_id, poll_id){
		let url: string = this.apiUrls.serviceBaseRest + `onboarding/user/processes/${process_id}/activity/poll/${poll_id}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	getActivityAssessments(process_id, topic_id){
		let url: string = this.apiUrls.serviceBaseRest + `onboarding/user/processes/${process_id}/activity/questions/${topic_id}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	getActivityChecklist(process_id, checklist_id){
		let url: string = this.apiUrls.serviceBaseRest + `onboarding/user/processes/${process_id}/activity/checklist/${checklist_id}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

  getActivityPasantia(process_id, activity_id, filter){
		let url: string = this.apiUrls.serviceBaseRest + `onboarding/user/processes/${process_id}/activity/pasantia/${activity_id}?search=${filter}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	saveActivityPasantia(process_id, activity_id, user_id, data) {
		let url: string = this.apiUrls.serviceBaseRest + `onboarding/user/processes/${process_id}/activity/pasantia/${activity_id}/save`;
		let params = {
			user_id,
			data
		};
		let promesa = this.http
			.post(url, JSON.stringify(params))
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	async cargarPregEncInduccion(process_id, poll_id) {
		if (process_id != null && poll_id != null) {
			await this.getActivityPoll(process_id, poll_id)
				.then(
					async (response) => {
						this.lista_encuesta = await response.data.questions;
					}
				)
				.catch((e) => {
					console.log(e.status, e.url);
				});
		}
	}


	getActivityChecklistUserByTrainer(process_id, activity_id, user_id){
		let url: string = this.apiUrls.serviceBaseRest + `onboarding/supervisor/processes/${process_id}/activity/checklist_by_trainer/${activity_id}/${user_id}`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	registerUserChecklist(process_id,activity_id, user_id){
		let url: string = this.apiUrls.serviceBaseRest + `onboarding/supervisor/processes/${process_id}/activity/register_user_checklist/${user_id}`;
		let params = {
			activity_id,
		};
		let promesa = this.http
			.post(url, JSON.stringify(params))
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	getImageCertificateProcess(process_id) {
		let url: string = this.apiUrls.serviceBaseRest + `onboarding/download_certificate_process`;
		let params = {
			process_id
		};
		let promesa = this.http
			.post(url, JSON.stringify(params))
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	registerReviewedCertificate(process_id) {
		let url: string = this.apiUrls.serviceBaseRest + `onboarding/register_reviewed_certificate`;
		let params = {
			process_id
		};
		let promesa = this.http
			.post(url, JSON.stringify(params))
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}
	saveActivity(process_id, activity_id, model_id) {
		let url: string = this.apiUrls.serviceBaseRest + `onboarding/user/processes/${process_id}/activity/register`;
		let params = {
			activity_id, model_id
		};
		let promesa = this.http
			.post(url, JSON.stringify(params))
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}
	saveChecklistActivity(process_id, activity_id, model_id, user_id) {
		let url: string = this.apiUrls.serviceBaseRest + `onboarding/user/processes/${process_id}/activity/register`;
		let params = {
			activity_id, model_id, user_id
		};
		let promesa = this.http
			.post(url, JSON.stringify(params))
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	cargarFaqsInduction() {
		return new Promise((resolve, reject) => {
			this.http
				.get(this.apiUrls.serviceBaseRest + "onboarding/faqs")
				.toPromise()
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}

	/**************** INDUCCIÓN  **************************/
	/**************** DESCARGAS OFFLINE  **************************/
	getEncryptedMultimedia(mediaID, topicID) {
		// {{local}}/api/rest/temas/download/{tema_id}/{multimedia_id
		let url: string = this.apiUrls.serviceBaseRest + `temas/download/${topicID}/${mediaID}`;
		let promesa = this.http
			.get(url, {responseType: "blob"})
			.toPromise()
			.then((response) => Promise.resolve(response))
			.catch((error) => Promise.reject(error));
		return promesa;
	}

	sendAuditOffline(courseID, downloadType, start, end) {
		let url =  this.apiUrls.serviceBaseRest + `cursos/audit-offline`;
		let body = {
			course_id : courseID,
			type: downloadType,
			starts_at: start,
			finishes_at: end
		}
		return this.http
			.post(url, body)
			.toPromise()
			.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
			.catch((error) => Promise.reject(error));

	}
	// getEncryptedMultimedia(mediaID, topicID) {
	// 	// {{local}}/api/rest/temas/download/{tema_id}/{multimedia_id
	// 	let url: string = this.apiUrls.serviceBaseRest + `temas/download/${topicID}/${mediaID}`;
	// 	let promesa = this.http
	// 		.get(url)
	// 		.toPromise()
	// 		.then((response) => Promise.resolve(JSON.parse(JSON.stringify(response))))
	// 		.catch((error) => Promise.reject(error));
	// 	return promesa;
	// }


	// **************** REWARDS  **************************/
  getRewardsConfig() {
    //GET: {{local}}/api/rest/rewards/coins
		let url: string = this.apiUrls.serviceBaseRest + `rewards/coins`;
		return this.http.get<any>(url);
	}
  getRewardHistory(currentPage) {
		let url: string = this.apiUrls.serviceBaseRest + `rewards/coin-records?page=${currentPage}`;
		return this.http.get<any>(url);
	}
  checkRewardCertificate(courseId) {
		let url: string = this.apiUrls.serviceBaseRest + `rewards/claim-certificate-coins`;
    let body = {
			course_id: courseId
		}
		return this.http.post<any>(url, body);
	}
  checkRewardScormInteractive(topic_id, media_id, skipAuthRedirect = false) {
		let url: string = this.apiUrls.serviceBaseRest + `rewards/claim-scorm`;
    let body = {
			topic_id,media_id
		}
		return this.http.post<any>(url, body, this.scormPlaybackOptions(skipAuthRedirect));
	}

  // **************** checklist inverso & knockout **************************/
  sendKnockout(checklistId, body, entity_id?) {
		let url: string = this.apiUrls.serviceBaseRest + `entrenamiento/v2/checklist/${checklistId}/aplicate-knockout?entity_id=${entity_id}`;
		return this.http.post<any>(url, body);
	}
  getActivitiesPerScaleResults(checklist_id, audit_identifier,qualification_id, page, perPage,search = "") {
    let url: string = this.apiUrls.serviceBaseRest + `entrenamiento/v2/trainer/checklists/${checklist_id}/instance-activity-detail?audit_identifier=${audit_identifier}&qualification_id=${qualification_id}&page=${page ? page : '' }&per_page=${perPage}&search=${search}`;
		return this.http.get<any>(url);
	}
  // **************** login personalizado multimarca **************************/
  getMultibrandLoginConfig(urlOrigin) {
    // let url: string = environment.URL_MASTER + `/api/custom-login?domain=https://selvasystem.cursalab.io`;
    let url: string = environment.URL_MASTER + `/api/custom-login?domain=${urlOrigin}`;
		return this.http.get<any>(url);
	}
  // **************** reportes checklist  **************************/
  getChecklistReports(checklist_id, audit_identifier, page, perPage) {
    let url: string = this.apiUrls.serviceBaseRest + `entrenamiento/v2/trainer/checklists/${checklist_id}/reports?audit_id=${audit_identifier}&page=${page ? page : '' }&per_page=${perPage}`;
		return this.http.get<any>(url);
	}
  requestNewReport(checklistId, body) {
    let url: string = this.apiUrls.serviceBaseRest + `entrenamiento/v2/trainer/checklists/${checklistId}/generate-report`;
    return this.http.post<any>(url, body);
  }
  requestInspectionRecord(checklistId, body) {
    let url: string = this.apiUrls.serviceBaseRest + `entrenamiento/v2/trainer/checklists/${checklistId}/generate-inspection-record`;
    return this.http.post<any>(url, body);
  }

  //**************** Login multiworkspace  **************************/
  loginSelectedWorkspace(subworkspaceId, platformId, os, userVersion) {
    const url: string = this.apiUrls.serviceBaseRest + `auth/clone`;
    const body = {
      subworkspace_id:subworkspaceId,
      platform_id:platformId,
      os: os,
      version: userVersion ? userVersion : null
    }
    return this.http.post<any>(url, body);
  }
  //**************** upgrade app  **************************/
  getVerifyAppVersion(typeValidation,typeClient, version, os) {
    let url: string = environment.URL_MASTER + `/api/check-app-version?type_validation=${typeValidation}&type_client=${typeClient}&version=${version}&os=${os}`;
		return this.http.get<any>(url);
	}

  //**************** language preference **************************/
  saveLanguagePreference(userLanguage) {
    const url: string = this.apiUrls.serviceBaseRest + `save_language`;
    const body = {
      userLanguage
    }
    return this.http.post<any>(url, body);
  }

  // **************** outsourced  **************************/
  getHistoryOutsourcedProcess(page,perPage) {
    let url: string = this.apiUrls.serviceBaseRest + `outsourced/history-user-process-massive?page=${page}&per_page=${perPage}`;
		return this.http.get<any>(url);
	}

  getPlatformCriteria() {
    let url: string = this.apiUrls.serviceBaseRest + `outsourced/init-data`;
		return this.http.get<any>(url);
	}
  // sendFileToVerifyErrors(file:File, columns) {
  //   let url: string = this.apiUrls.serviceBaseRest + `outsourced/upload-file`;
  //   const body = {
  //     file: "",
  //     settings: {
  //       columns: []
  //     }
  //   }
	// 	return this.http.post<any>(url, body);
	// }
  sendFileToVerifyErrors(file:File, columns, actionType) {
    let url: string = this.apiUrls.serviceBaseRest + `outsourced/upload-file`;
    const token: string = localStorage.getItem("token");
    let data_usuario = JSON.parse(localStorage.getItem("user_data"));

    const workstation = {
      platform: data_usuario?.onboarding ? "onboarding" : "training",
      platform_id: data_usuario?.current_platform?.id,
      workspace: data_usuario?.workspace?.slug,
      workspace_id: data_usuario?.workspace?.id,
      subworkspace: data_usuario?.module?.slug,
      subworkspace_id: data_usuario?.module?.id,
    }

    // Crear un FormData para enviar el archivo
    const formData = new FormData();
    formData.append('file', file);
    formData.append('settings', JSON.stringify(columns));
    formData.append("type", actionType);
    formData.append("workstation", JSON.stringify(workstation));
    formData.append("userLanguage", this.language);

    return fetch(url, {
      method: "POST",
      body: formData,
      headers: {
        'Authorization':`Bearer ${token}`,
        'Accept':`application/json, */*`
      }
    })
    .then( res => res.json() )
	}

  saveOutsourcedProcess(file:File, columns, actionType) {
    let url: string = this.apiUrls.serviceBaseRest + `outsourced/save-process`;
    const token: string = localStorage.getItem("token");
    let data_usuario = JSON.parse(localStorage.getItem("user_data"));

    const workstation = {
      platform: data_usuario?.onboarding ? "onboarding" : "training",
      platform_id: data_usuario?.current_platform?.id,
      workspace: data_usuario?.workspace?.slug,
      workspace_id: data_usuario?.workspace?.id,
      subworkspace: data_usuario?.module?.slug,
      subworkspace_id: data_usuario?.module?.id,
    }

    // Crear un FormData para enviar el archivo
    const formData = new FormData();
    formData.append('file', file);
    formData.append('settings', JSON.stringify(columns));
    formData.append("type", actionType);
    formData.append("workstation", JSON.stringify(workstation));
    formData.append("userLanguage", this.language);

    return fetch(url, {
      method: "POST",
      body: formData,
      headers: {
        'Authorization':`Bearer ${token}`,
        'Accept':`application/json, */*`
      }
    })
    .then( res => res.json() )
	}

  getHighlightedCourses() {
    let url: string = this.apiUrls.serviceBaseRest + `cursos/destacados`;
		return this.http.get<any>(url);
	}

  // **************** INICIO (home) **************************/
  // Todavía sin desplegar: `HomeHttpDataSource` no los llama hasta que existan.

  /** Contadores del Inicio: actividades de hoy y avance de cursos y checklist. */
  getHomeSummary() {
    const url: string = this.apiUrls.serviceBaseRest + `home/summary`;
    return this.http.get<HomeSummaryResponse>(url);
  }

  /** Análisis diario de Isa para el Inicio. */
  getHomeIsaAnalysis() {
    const url: string = this.apiUrls.serviceBaseRest + `home/isa-analysis`;
    return this.http.get<HomeIsaAnalysisResponse>(url);
  }

  // ************* checklist offline *************************/
  	getChecklistRawData(checklistID):any {
		let url: string = this.apiUrls.serviceBaseRest + `entrenamiento/v2/trainer/checklists/${checklistID}/donwload-data`;
		let promesa = this.http
			.get(url)
			.toPromise()
			.then((response) => Promise.resolve(response))
			.catch((error) => Promise.reject(error));
		return promesa;
	}
  // syncActivitiesBatch(checklistID, activities) {
  //   console.log("api syncActivitiesBatch",checklistID, activities)
	// 	let url: string = this.apiUrls.serviceBaseRest + `entrenamiento/v2/trainer/checklists/${checklistID}/save-activities-offline`;
  //   const datos = activities
  //   return this.http.post<any>(url, datos);
  // }

  finishChecklistOffline(checklistID, checklistData) {
    // console.log("api finishChecklistOffline",checklistID, checklistData)

		let url: string = this.apiUrls.serviceBaseRest + `entrenamiento/v2/trainer/checklists/${checklistID}/save-instance-offline`;
    const datos = checklistData
    return this.http.post<any>(url, datos);

  }

  syncActivitiesBatch(checklistID, activities) {
  let url = `${this.apiUrls.serviceBaseRest}entrenamiento/v2/trainer/checklists/${checklistID}/save-activities-offline`;
  const token: string = localStorage.getItem("token");
  let data_usuario = JSON.parse(localStorage.getItem("user_data"));

  const workstation = {
    platform: data_usuario?.onboarding ? "onboarding" : "training",
    platform_id: data_usuario?.current_platform?.id,
    workspace: data_usuario?.workspace?.slug,
    workspace_id: data_usuario?.workspace?.id,
    subworkspace: data_usuario?.module?.slug,
    subworkspace_id: data_usuario?.module?.id,
  }

  const formData = new FormData();

  activities.forEach((activity, activityIndex) => {
    // Agregar campos de actividad
    formData.append(`activities[${activityIndex}][checklist_id]`, activity.checklist_id);
    formData.append(`activities[${activityIndex}][entity_id]`, activity.entity_id);
    formData.append(`activities[${activityIndex}][activity_id]`, activity.activity_id);
    formData.append(`activities[${activityIndex}][qualification_id]`, JSON.stringify(activity.qualification_id) );
    formData.append(`activities[${activityIndex}][qualification_response]`, activity.qualification_response);
    formData.append(`activities[${activityIndex}][date_audit]`, activity.date_audit);
    formData.append(`activities[${activityIndex}][comment]`, JSON.stringify(activity.comment));

    // Agregar fotos si existen
    if (activity.photos && activity.photos.length) {
      activity.photos.forEach((photo, photoIndex) => {
        formData.append(`activities[${activityIndex}][photos][${photoIndex}]`, JSON.stringify(photo));
      });
    }

    // Agregar videos si existen
    if (activity.videos && activity.videos.length) {
      activity.videos.forEach((video, videoIndex) => {
		// const fileName = `video_${Date.now()}.mp4`;
        // console.log(`log: activities[${activityIndex}][videos][${videoIndex}][file_video]: `,video)
        if(video.action === "delete") {
          formData.append(`activities[${activityIndex}][videos][${videoIndex}][file_video]`, video.file_video);
        } else {
          formData.append(`activities[${activityIndex}][videos][${videoIndex}][file_video]`, video.file_video, video.fileName);
        };

        formData.append(`activities[${activityIndex}][videos][${videoIndex}][datetime]`, video.datetime);
        formData.append(`activities[${activityIndex}][videos][${videoIndex}][from]`, video.from);
        formData.append(`activities[${activityIndex}][videos][${videoIndex}][action]`, video.action);
        formData.append(`activities[${activityIndex}][videos][${videoIndex}][video]`, video.video);
      });
    }
  });

  formData.append("workstation", JSON.stringify(workstation));
  formData.append("userLanguage", this.language);

//   return this.http.post<any>(url, formData);

  return fetch(url, {
      method: "POST",
      body: formData,
      headers: {
        'Authorization':`Bearer ${token}`,
        'Accept':`application/json, */*`
      }
    })
    .then( async (res) => {
    if (!res.ok) {
      // Si la respuesta no es exitosa, lanzamos un error
      const error = await res.json().catch(() => ({}));
      throw error;
	  }
	  return res.json();
		// if (!res.ok) {
    //   	// Si la respuesta no es exitosa, lanzamos un error
		// const error = await res.json().catch(() => ({}));
		// throw new Error(`HTTP error! status: ${res.status}, message: ${error.message || 'Unknown error'}`);
		// }
		// return res.json();
	})
}

  saveScormConfig(file_path, scorm_auto_completion_detected, scorm_evaluates_and_records_grade,scorm_records_last_page, user_id, urlBase ) {
    let url:string = "";
		if(urlBase) {
			 url = urlBase + `/api/verify-topic-scorm`;
		} else {
			url = this.apiUrls.serviceBase + `verify-topic-scorm`;
		}
    const body = {
      scorm_auto_completion_detected,
      scorm_evaluates_and_records_grade,
      scorm_records_last_page,
      file_path,
      user_id
    }
    return this.http.post<any>(url, body);
  }
 // **** CALENDAR ******
  getCalendarEvents(starts_at, finishes_at) {
    let url: string = this.apiUrls.serviceBaseRest + `user-notification/scheduled?starts_at=${starts_at}&finishes_at=${finishes_at}&timezone=${Intl.DateTimeFormat().resolvedOptions().timeZone}`;
		return this.http.get<any>(url);
	}

  getCalendarEventData(custom_id, eventCode) {
    // http://gestor.test/api/rest/user-notification/scheduled/detail?custom_id type get
    let url: string = this.apiUrls.serviceBaseRest + `user-notification/scheduled/detail?custom_id=${custom_id}&code=${eventCode}`;
		return this.http.get<any>(url);
	}

  requestEventIntegration(event) {
    const url: string = this.apiUrls.serviceBaseRest + `user-notification/add-calendar`;
    const body = {event};
    return this.http.post<any>(url, body);
  }

  /*************** ROLEPLAY / EVALUACIÓN PRÁCTICA *******************/

  /**
   * Configuración del roleplay del tema: escenario (título, contexto,
   * objetivos) y el personaje que interpreta la IA.
   *
   * No abre nada ni consume intento: es solo lectura, y va por separado de la
   * sesión justamente para que la página pueda pedirla en paralelo.
   */
  obtenerTopicRoleplay(topic_id: string | number) {
    const url: string = this.apiUrls.serviceBaseRest + `roleplay/topics/${topic_id}`;
    return this.http.get<RoleplayTopicResponseDto>(url);
  }

  /**
   * Abre la sesión del roleplay y devuelve el primer turno del personaje.
   * El tema viaja en la URL y el body va vacío.
   * En las modalidades `voice` y `video` el `opening` trae además el audio.
   */
  iniciarSesionRoleplay(topic_id: string | number) {
    const url: string = this.apiUrls.serviceBaseRest + `roleplay/topics/${topic_id}/sessions`;
    return this.http.post<RoleplayStartResponseDto>(url, {});
  }

  /** Turno del usuario en modalidad chat: el body lleva solo el texto. */
  enviarTurnoTextoRoleplay(session_id: string, data: RoleplayTextTurnRequestDto) {
    const url: string = this.apiUrls.serviceBaseRest + `roleplay/sessions/${session_id}/turns-text`;
    return this.http.post<RoleplayTurnResponseDto>(url, data);
  }

  /**
   * Turno del usuario en las modalidades de voz y video: sube la grabación y
   * backend devuelve la transcripción junto a la respuesta del personaje.
   *
   * La llave del multipart es `audio` en las dos modalidades, y lo que se sube
   * es **siempre un archivo de audio**: en video la imagen no viaja acá, va por
   * `enviarFramesRoleplay()`. Es la única llave: backend ya tiene el resto desde
   * la sesión.
   *
   * Va con `HttpClient` y no con `fetch()` como las demás subidas del archivo:
   * los interceptors ya respetan los bodies `FormData` (no fuerzan el
   * `Content-Type` ni pisan el body), así que la petición conserva el token y
   * los datos de `workstation` sin trabajo extra.
   */
  enviarTurnoMediaRoleplay(session_id: string, archivo: Blob, fileName: string) {
    const url: string = this.apiUrls.serviceBaseRest + `roleplay/sessions/${session_id}/turns`;

    const formData = new FormData();
    formData.append('audio', archivo, fileName);

    return this.http.post<RoleplayTurnResponseDto>(url, formData);
  }

  /**
   * Muestras de la cámara para el análisis de expresiones (solo modalidad video).
   *
   * Es independiente de `turns`: no lleva la respuesta del usuario, solo las
   * imágenes que se van tomando durante la conversación. Cada frame es un JPEG
   * en base64 puro (sin el prefijo `data:`). La respuesta se recibe y no se
   * pinta: el análisis llega al usuario dentro del resultado de `/end`.
   */
  enviarFramesRoleplay(session_id: string, frames: string[]) {
    const url: string = this.apiUrls.serviceBaseRest + `roleplay/sessions/${session_id}/frames`;
    return this.http.post<RoleplayFramesResponseDto>(url, { frames });
  }

  /**
   * Cierra la sesión y devuelve la rúbrica con el resultado.
   * El body va vacío: backend resuelve todo desde la sesión.
   */
  finalizarSesionRoleplay(session_id: string) {
    const url: string = this.apiUrls.serviceBaseRest + `roleplay/sessions/${session_id}/end`;
    return this.http.post<RoleplayEndResponseDto>(url, {});
  }

  /**
   * Token efímero con el que el navegador abre el canal WebRTC de la modalidad
   * stream. Lo único que hace el backend en esa conversación: la negociación SDP
   * y el audio van **directo navegador ↔ OpenAI**.
   *
   * ⚠️ El token es de un solo uso y caduca. Reconectar exige pedir otro.
   * Devuelve 400 si el escenario no soporta streaming.
   */
  obtenerTokenRealtimeRoleplay(session_id: string) {
    const url: string = this.apiUrls.serviceBaseRest + `roleplay/sessions/${session_id}/realtime-token`;
    return this.http.post<RoleplayRealtimeTokenDto>(url, {});
  }

  /**
   * Registra un turno de la llamada en vivo: es la bitácora con la que backend
   * puntúa la sesión cuando se cierre con `/end`.
   *
   * Va multipart por el `audio` del trainee. **La conversación en sí no pasa por
   * acá** —el audio del canal es directo navegador ↔ OpenAI—, pero OpenAI
   * devuelve solo el *texto* de lo que dijo el usuario, y la rúbrica necesita su
   * voz para puntuar entonación. Por eso el navegador la graba en paralelo y la
   * adjunta acá (ver la sección de streaming en `tema/CLAUDE.md`). Es opcional: si
   * la grabación falla, el turno se reporta igual sin ella.
   *
   * Igual que en `enviarTurnoMediaRoleplay`, los interceptors ya respetan los
   * bodies `FormData`, así que conserva token y datos de `workstation` sin
   * trabajo extra.
   */
  reportarTurnoRealtimeRoleplay(
    session_id: string,
    role: RoleplayRealtimeRole,
    text: string,
    usage?: string,
    audio?: Blob,
    audioFileName?: string
  ) {
    const url: string = this.apiUrls.serviceBaseRest + `roleplay/sessions/${session_id}/realtime-turn`;

    const formData = new FormData();
    formData.append('role', role);
    formData.append('text', text);
    if (usage) formData.append('usage', usage);
    if (audio) formData.append('audio', audio, audioFileName);

    return this.http.post<RoleplayRealtimeTurnResponseDto>(url, formData);
  }

  /*************** ROLEPLAY COMO ACTIVIDAD (vista "Roleplays") *******************/

  /**
   * Roleplays asignados al usuario, para el listado de la vista "Roleplays".
   *
   * Trae los dos grupos ya separados en la misma respuesta (`data.free` y
   * `data.topic`), cada uno con su `label` y su `count`, más un bloque `counts`
   * con los totales de cada filtro.
   *
   * Los filtros son opcionales y hoy no los manda nadie: el listado es corto y
   * la vista sigue filtrando en cliente sobre lo que devuelve esta llamada. Van
   * en la firma porque el endpoint ya los soporta.
   */
  listarRoleplays(filtros: RoleplayMineAllFiltros = {}) {
    const url: string = this.apiUrls.serviceBaseRest + `roleplay/mine-all`;

    let params = new HttpParams();
    if (filtros.type) params = params.set('type', filtros.type);
    if (filtros.status) params = params.set('status', filtros.status);
    // Solo cuando se piden los evaluables: `evaluable=0` no es "los no
    // evaluables", es no filtrar, y para eso se omite la llave.
    if (filtros.evaluable) params = params.set('evaluable', '1');

    return this.http.get<RoleplayMineAllResponseDto>(url, { params });
  }

  /**
   * Configuración de un roleplay **libre** (`source: 'free'`): escenario y
   * personaje.
   *
   * Equivalente de `obtenerTopicRoleplay()` para los que no cuelgan de ningún
   * tema. Igual que aquel, es solo lectura y no consume intento.
   *
   * El id es el `id` del item del grupo `free` de `roleplay/mine-all`. Los del
   * grupo `topic` no pasan por acá: usan `obtenerTopicRoleplay()`.
   */
  obtenerRoleplayLibre(roleplay_free_id: string | number) {
    const url: string = this.apiUrls.serviceBaseRest + `roleplay/free/${roleplay_free_id}/config`;
    return this.http.get<RoleplayTopicResponseDto>(url);
  }

  /**
   * Abre la sesión de un roleplay **libre** y devuelve el primer turno del
   * personaje. Body vacío, igual que la de tema.
   *
   * Los del grupo `topic` abren su sesión con `iniciarSesionRoleplay(topic_id)`,
   * que es además el que descuenta el intento del tema y actualiza su nota.
   */
  iniciarSesionRoleplayLibre(roleplay_free_id: string | number) {
    const url: string = this.apiUrls.serviceBaseRest + `roleplay/free/${roleplay_free_id}/sessions`;
    return this.http.post<RoleplayStartResponseDto>(url, {});
  }

  /**
   * Configuración de un roleplay abierto **por link** (`roleplay/links/{id}/config`).
   *
   * Es la entrada de un roleplay de **curso** en una ruta de aprendizaje: un hito que no cuelga de
   * ningún tema, así que no tiene `topic_id` con el que pedir `roleplay/topics/{topic}`. El id es el
   * `roleplay_target_id` que manda el `ref` del hito (`RefRoleplay`).
   *
   * No reemplaza a ninguno de los otros dos: un roleplay **de tema** —también dentro de una ruta—
   * sigue yendo por el par de producción, que es el que descuenta el intento del tema.
   *
   * ⚠️ Endpoint nuevo: documentado por backend pero todavía no desplegado en `test4` (fase 5z).
   * Mientras tanto el recorrido solo se puede caminar con el mock del roleplay
   * (`RoleplayService.USE_MOCK`); contra la API real responde 404.
   */
  obtenerConfigRoleplayLink(roleplay_target_id: string | number) {
    const url: string = this.apiUrls.serviceBaseRest + `roleplay/links/${roleplay_target_id}/config`;
    return this.http.get<RoleplayTopicResponseDto>(url);
  }

  /**
   * Abre la sesión de un roleplay por link y devuelve el primer turno del personaje. Body vacío,
   * igual que las de tema y libre.
   *
   * ⚠️ Mismo aviso que `obtenerConfigRoleplayLink`: todavía no está en `test4`.
   */
  iniciarSesionRoleplayLink(roleplay_target_id: string | number) {
    const url: string = this.apiUrls.serviceBaseRest + `roleplay/links/${roleplay_target_id}/sessions`;
    return this.http.post<RoleplayStartResponseDto>(url, {});
  }

  /**
   * Resultado guardado de UNA sesión concreta.
   *
   * Es lo que hace posible "Ver resultados previos": el listado manda la sesión
   * del último intento (`last_session_id`) y con ella se relee. A diferencia de
   * `/end`, no cierra ni puntúa nada, así que se puede pedir cuantas veces haga
   * falta.
   *
   * Devuelve el mismo cuerpo de `/end` —rúbrica, transcripción y todo— más el
   * bloque `evaluation` con los datos del intento (nota, intentos, validador).
   */
  obtenerResultadoSesionRoleplay(session_id: string) {
    const url: string = this.apiUrls.serviceBaseRest + `roleplay/sessions/${session_id}/results`;
    return this.http.get<RoleplaySessionResultsDto>(url);
  }

}
